/* hs-quiz build 8ff6f3fabc3e */
window.HSQ_BUILD = "8ff6f3fabc3e";
// The quiz's brain, shared by the storefront and the PO admin.
//
// One file, no dependencies, runs in Node (module.exports) and in the browser
// (window.HSQuizEngine). The matching logic is a straight port of what ran in
// sections/main-quiz.liquid — weighted criteria, hard/soft/ordinal/superset
// modes, minimum-penalty relaxation, in-stock first — so results are identical
// for identical answers. What is new lives around it: questions come from a
// config document instead of theme blocks, a question can depend on ANY
// earlier answer (not only the category), and the config can be validated
// against the real catalogue before it is saved.
//
// Vocabulary
//   config    { categories[], category_question, questions[], rules{}, results{}, texts{} }
//   answers   { category: 'bodysuit', quiz_style: 'under', ... }   keyed by question key
//   product   { id, title, url, image, price, category, specs{key: value|[values]}, in_stock?, variants?[] }
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.HSQuizEngine = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var CATEGORY = 'category';
  var MODES = ['soft', 'exclude', 'ordinal', 'superset'];

  // Same normaliser the theme used: case, whitespace and punctuation are
  // ignored, so "Comp 1-2", "comp_1_2" and "COMP12" are the same value.
  function clean(str) {
    if (str === undefined || str === null) return '';
    if (typeof str !== 'string') str = Array.isArray(str) ? str.join(',') : String(str);
    return str.toLowerCase().replace(/[\s\-_,./\\()]/g, '').trim();
  }

  // A product's declared values for one key. Metafields arrive in several
  // shapes — a single value, a list, a JSON-encoded list ("[\"a\",\"b\"]"),
  // or a comma/semicolon string — and all of them must read the same.
  function specValues(raw) {
    if (raw === undefined || raw === null || raw === '') return [];
    if (Array.isArray(raw)) return raw.map(clean).filter(Boolean);
    var s = String(raw).trim();
    if (s.charAt(0) === '[') {
      try { var arr = JSON.parse(s); if (Array.isArray(arr)) return arr.map(clean).filter(Boolean); } catch (e) { /* not JSON */ }
    }
    return s.split(/[,;]/).map(clean).filter(Boolean);
  }

  function ruleFor(config, key) {
    var rules = (config && config.rules) || {};
    var r = rules[key];
    if (r) return r;
    var q = questionByKey(config, key);
    return { weight: 1, mode: 'soft', label: (q && (q.eyebrow || q.title)) || key };
  }

  function questionByKey(config, key) {
    var qs = (config && config.questions) || [];
    for (var i = 0; i < qs.length; i++) if (qs[i].key === key) return qs[i];
    return null;
  }

  // status: match | near | miss | unknown. "unknown" means the product does
  // not declare the field — ranked as a miss, but never a contradiction, so
  // an incomplete metafield cannot hide a product entirely.
  function evaluateCriterion(config, key, answer, raw) {
    var rule = ruleFor(config, key);
    var nearCredit = (config && config.results && typeof config.results.near_credit === 'number') ? config.results.near_credit : 0.45;
    var want = clean(answer);
    var have = specValues(raw);
    if (!want || !have.length) return { status: 'unknown', credit: 0, contradiction: false };
    if (have.indexOf(want) !== -1) return { status: 'match', credit: 1, contradiction: false };

    if (rule.mode === 'superset' && rule.covers) {
      for (var i = 0; i < have.length; i++) {
        var covered = rule.covers[have[i]];
        if (!covered) {
          // covers keys are written by humans — match them normalised too
          for (var ck in rule.covers) if (clean(ck) === have[i]) { covered = rule.covers[ck]; break; }
        }
        if (covered && covered.map(clean).indexOf(want) !== -1) return { status: 'match', credit: 1, contradiction: false };
      }
      return { status: 'miss', credit: 0, contradiction: false };
    }

    if (rule.mode === 'ordinal' && rule.scale) {
      var scale = rule.scale.map(clean);
      var wantIdx = scale.indexOf(want);
      var best = null;
      for (var j = 0; j < have.length; j++) {
        var idx = scale.indexOf(have[j]);
        if (idx === -1 || wantIdx === -1) continue;
        var dist = Math.abs(idx - wantIdx);
        if (best === null || dist < best) best = dist;
      }
      if (best === null) return { status: 'miss', credit: 0, contradiction: false };
      if (best === 0) return { status: 'match', credit: 1, contradiction: false };
      var limit = rule.excludeBeyond === undefined || rule.excludeBeyond === null ? 99 : rule.excludeBeyond;
      if (best <= limit) return { status: 'near', credit: nearCredit, contradiction: false };
      return { status: 'miss', credit: 0, contradiction: true };
    }

    if (rule.mode === 'exclude') return { status: 'miss', credit: 0, contradiction: true };
    return { status: 'miss', credit: 0, contradiction: false };
  }

  // ── Branching ──────────────────────────────────────────────────────────────
  // question.show_when = [{ q: 'category', in: ['bodysuit'] }, { q: 'quiz_style', not_in: ['under'] }]
  // Every condition must hold. A condition on a question that has no answer
  // (hidden, or not reached yet) fails — so a dependent question only appears
  // once its parent has been answered.
  function conditionHolds(cond, answers) {
    if (!cond || !cond.q) return true;
    var val = answers ? answers[cond.q] : undefined;
    if (val === undefined || val === null || val === '') return false;
    var v = clean(val);
    if (Array.isArray(cond['in'])) return cond['in'].map(clean).indexOf(v) !== -1;
    if (Array.isArray(cond.not_in)) return cond.not_in.map(clean).indexOf(v) === -1;
    return true;
  }

  function isVisible(question, answers) {
    if (!question || question.enabled === false) return false;
    var conds = question.show_when || [];
    for (var i = 0; i < conds.length; i++) if (!conditionHolds(conds[i], answers)) return false;
    return true;
  }

  // The questions this visitor will see, in order, given what they answered
  // so far. Two config entries may share a metafield key (the same question
  // worded differently per category) — only the first visible one is kept.
  function visibleQuestions(config, answers) {
    var out = [], seen = {};
    var qs = (config && config.questions) || [];
    for (var i = 0; i < qs.length; i++) {
      var q = qs[i];
      if (!q || !q.key || !isVisible(q, answers)) continue;
      if (seen[q.key]) continue;
      seen[q.key] = true;
      out.push(q);
    }
    return out;
  }

  // Drop answers to questions that are no longer on the path — she changed an
  // earlier answer and a branch closed. Iterates because closing one branch
  // can close another that depended on it.
  function pruneAnswers(config, answers) {
    var kept = {};
    if (answers && answers[CATEGORY]) kept[CATEGORY] = answers[CATEGORY];
    var changed = true, guard = 0;
    while (changed && guard++ < 20) {
      changed = false;
      var vis = visibleQuestions(config, kept);
      for (var i = 0; i < vis.length; i++) {
        var k = vis[i].key;
        if (answers[k] !== undefined && answers[k] !== null && answers[k] !== '' && kept[k] === undefined) {
          kept[k] = answers[k];
          changed = true;
        }
      }
    }
    return kept;
  }

  // Options a visitor can pick: a label and a tag are both required.
  function activeOptions(question) {
    return ((question && question.options) || []).filter(function (o) {
      return o && o.enabled !== false && String(o.label || '').trim() && String(o.tag || '').trim();
    });
  }

  function inStock(p) {
    if (typeof p.in_stock === 'boolean') return p.in_stock;
    var v = p.variants || [];
    if (!v.length) return true;
    for (var i = 0; i < v.length; i++) if (v[i].available) return true;
    return false;
  }

  // ── Recommendation ─────────────────────────────────────────────────────────
  function recommend(config, products, answers) {
    products = products || [];
    answers = pruneAnswers(config, answers || {});
    var results = (config && config.results) || {};
    var fallbackCount = results.fallback_count || 3;

    var targetCategory = clean(answers[CATEGORY]);
    var activeKeys = visibleQuestions(config, answers).map(function (q) { return q.key; })
      .filter(function (k) { return answers[k] !== undefined && answers[k] !== null && answers[k] !== ''; });

    var pool = products.filter(function (p) { return clean(p.category) === targetCategory; });
    if (!pool.length) {
      var any = products.slice().sort(function (a, b) {
        var as = inStock(a), bs = inStock(b);
        if (as !== bs) return as ? -1 : 1;
        return (a.price || 0) - (b.price || 0);
      }).slice(0, fallbackCount).map(function (p) { return withResult(p, null, {}, 0); });
      return { products: any, relaxed: [], relaxedKeys: [], isFallback: true, poolSize: 0, emptyCategory: true, activeKeys: activeKeys };
    }

    var scored = pool.map(function (p) {
      var score = 0, max = 0, criteria = {}, bad = [];
      activeKeys.forEach(function (k) {
        var rule = ruleFor(config, k);
        var ev = evaluateCriterion(config, k, answers[k], p.specs ? p.specs[k] : null);
        criteria[k] = ev;
        max += rule.weight;
        score += rule.weight * ev.credit;
        if (ev.contradiction) bad.push(k);
      });
      return { p: p, score: score, max: max, criteria: criteria, bad: bad };
    });

    // Relax the minimum: keep whichever products break the least valuable set
    // of rules, rather than dropping rules one at a time and over-relaxing.
    function penalty(s) {
      return s.bad.reduce(function (n, k) { return n + ruleFor(config, k).weight; }, 0);
    }
    var minPenalty = Math.min.apply(null, scored.map(penalty));
    var survivors = scored.filter(function (s) { return penalty(s) === minPenalty; });

    var relaxedSet = {};
    survivors.forEach(function (s) { s.bad.forEach(function (k) { relaxedSet[k] = true; }); });
    var relaxedKeys = Object.keys(relaxedSet);

    survivors.sort(function (a, b) {
      var as = inStock(a.p), bs = inStock(b.p);
      if (as !== bs) return as ? -1 : 1;
      if (b.score !== a.score) return b.score - a.score;
      return (a.p.price || 0) - (b.p.price || 0);
    });

    var out = survivors.map(function (s) {
      var pct = s.max ? Math.round(s.score / s.max * 100) : 100;
      var matches = Object.keys(s.criteria).filter(function (k) { return s.criteria[k].status === 'match'; }).length;
      return withResult(s.p, pct, s.criteria, matches);
    });

    var relaxed = relaxedKeys.map(function (k) { return ruleFor(config, k).label || k; });
    var isFallback = relaxedKeys.length > 0 || !out.length || out[0].matchPercent < 100;
    return { products: out, relaxed: relaxed, relaxedKeys: relaxedKeys, isFallback: isFallback, poolSize: pool.length, emptyCategory: false, activeKeys: activeKeys };
  }

  function withResult(p, pct, criteria, matches) {
    var copy = {};
    for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) copy[k] = p[k];
    copy.matchPercent = pct;
    copy.matchCriteria = criteria;
    copy.matchScore = matches;
    copy.inStock = inStock(p);
    return copy;
  }

  // ── Validation ─────────────────────────────────────────────────────────────
  // errors  → the config must not be saved
  // warnings → worth a look (a tag no product carries, a category with no products)
  // catalog is optional: { products: [...] } — enables the cross-checks.
  function validateConfig(config, catalog) {
    var errors = [], warnings = [];
    var err = function (path, msg) { errors.push({ path: path, message: msg }); };
    var warn = function (path, msg) { warnings.push({ path: path, message: msg }); };

    if (!config || typeof config !== 'object') { err('', 'config must be an object'); return { errors: errors, warnings: warnings }; }

    var cats = Array.isArray(config.categories) ? config.categories : [];
    if (!cats.length) err('categories', 'at least one category is required');
    var catKeys = {};
    cats.forEach(function (c, i) {
      var p = 'categories[' + i + ']';
      if (!c || !String(c.key || '').trim()) return err(p + '.key', 'category key is required');
      if (!String(c.label || '').trim()) err(p + '.label', 'category label is required');
      var ck = clean(c.key);
      if (catKeys[ck]) err(p + '.key', 'duplicate category key "' + c.key + '"');
      catKeys[ck] = c;
    });
    var enabledCats = cats.filter(function (c) { return c && c.enabled !== false && c.key; });
    if (cats.length && !enabledCats.length) err('categories', 'every category is disabled');

    var qs = Array.isArray(config.questions) ? config.questions : [];
    if (!qs.length) err('questions', 'at least one question is required');
    var keyToIdx = {};
    qs.forEach(function (q, i) {
      var p = 'questions[' + i + ']';
      if (!q || typeof q !== 'object') return err(p, 'question must be an object');
      if (!String(q.key || '').trim()) err(p + '.key', 'question key (metafield key) is required');
      else if (!/^[a-z0-9_]+$/i.test(q.key)) err(p + '.key', 'key "' + q.key + '" may only contain letters, digits and _');
      if (!String(q.title || '').trim()) err(p + '.title', 'question title is required');
      var opts = activeOptions(q);
      if (opts.length < 2) err(p + '.options', 'a question needs at least 2 options with a label and a tag');
      var seenTags = {};
      (q.options || []).forEach(function (o, j) {
        var op = p + '.options[' + j + ']';
        if (!o || o.enabled === false) return;
        var hasLabel = String(o.label || '').trim(), hasTag = String(o.tag || '').trim();
        if (hasLabel && !hasTag) err(op + '.tag', 'option "' + o.label + '" has no tag');
        if (!hasLabel && hasTag) warn(op + '.label', 'option with tag "' + o.tag + '" has no label and is hidden');
        if (hasTag) {
          var t = clean(o.tag);
          if (seenTags[t]) err(op + '.tag', 'duplicate tag "' + o.tag + '" in the same question');
          seenTags[t] = true;
        }
      });
      (q.show_when || []).forEach(function (c, j) {
        var cp = p + '.show_when[' + j + ']';
        if (!c || !c.q) return err(cp, 'condition needs "q"');
        if (c.q !== CATEGORY) {
          var ref = keyToIdx[c.q];
          if (ref === undefined) err(cp + '.q', 'refers to "' + c.q + '" which is not an earlier question (only earlier questions or "category")');
        }
        var list = Array.isArray(c['in']) ? c['in'] : (Array.isArray(c.not_in) ? c.not_in : null);
        if (!list || !list.length) err(cp, 'condition needs a non-empty "in" or "not_in" list');
        else if (c.q === CATEGORY) {
          list.forEach(function (v) { if (!catKeys[clean(v)]) err(cp, 'unknown category "' + v + '"'); });
        } else if (keyToIdx[c.q] !== undefined) {
          var parentTags = activeOptions(qs[keyToIdx[c.q]]).map(function (o) { return clean(o.tag); });
          list.forEach(function (v) { if (parentTags.indexOf(clean(v)) === -1) warn(cp, 'value "' + v + '" is not an option of "' + c.q + '"'); });
        }
      });
      if (q.key && keyToIdx[q.key] === undefined) keyToIdx[q.key] = i;
    });

    // Two questions with the same key must never be visible together — the
    // second would be silently skipped.
    var byKey = {};
    qs.forEach(function (q, i) { if (q && q.key) (byKey[q.key] = byKey[q.key] || []).push(i); });
    Object.keys(byKey).forEach(function (k) {
      var idxs = byKey[k];
      if (idxs.length < 2) return;
      for (var a = 0; a < idxs.length; a++) for (var b = a + 1; b < idxs.length; b++) {
        var ca = categorySet(qs[idxs[a]]), cb = categorySet(qs[idxs[b]]);
        var overlap = !ca || !cb || ca.some(function (x) { return cb.indexOf(x) !== -1; });
        if (overlap) err('questions[' + idxs[b] + ']', 'question key "' + k + '" is also used by questions[' + idxs[a] + '] for the same category — split them with show_when on category');
      }
    });

    var rules = config.rules || {};
    Object.keys(rules).forEach(function (k) {
      var r = rules[k], p = 'rules.' + k;
      if (!r || typeof r !== 'object') return err(p, 'rule must be an object');
      if (typeof r.weight !== 'number' || !(r.weight > 0)) err(p + '.weight', 'weight must be a number > 0');
      if (MODES.indexOf(r.mode) === -1) err(p + '.mode', 'mode must be one of ' + MODES.join(', '));
      if (r.mode === 'ordinal' && (!Array.isArray(r.scale) || r.scale.length < 2)) err(p + '.scale', 'ordinal rule needs a scale of at least 2 values');
      if (r.mode === 'superset' && (!r.covers || typeof r.covers !== 'object')) err(p + '.covers', 'superset rule needs "covers"');
      if (keyToIdx[k] === undefined) warn(p, 'rule for "' + k + '" has no question');
      if (r.mode === 'ordinal' && Array.isArray(r.scale) && keyToIdx[k] !== undefined) {
        var tags = [];
        qs.forEach(function (q) { if (q && q.key === k) activeOptions(q).forEach(function (o) { tags.push(clean(o.tag)); }); });
        r.scale.forEach(function (v) { if (tags.indexOf(clean(v)) === -1) warn(p + '.scale', 'scale value "' + v + '" is not an option tag of the question'); });
      }
    });
    qs.forEach(function (q, i) { if (q && q.key && !rules[q.key]) warn('questions[' + i + ']', 'no rule for "' + q.key + '" — it counts with weight 1 (soft)'); });

    var res = config.results || {};
    if (res.count !== undefined && !(res.count >= 1 && res.count <= 12)) err('results.count', 'results.count must be 1..12');
    if (res.near_credit !== undefined && !(res.near_credit >= 0 && res.near_credit <= 1)) err('results.near_credit', 'near_credit must be 0..1');

    // Against the live catalogue: does every tag exist on at least one product
    // of a category where the question is asked?
    if (catalog && Array.isArray(catalog.products) && !errors.length) {
      var prods = catalog.products;
      var summary = metafieldValueSummary(prods);
      enabledCats.forEach(function (c) {
        var n = prods.filter(function (p) { return clean(p.category) === clean(c.key); }).length;
        if (!n) warn('categories.' + c.key, 'no product carries quiz_category "' + c.key + '"');
      });
      qs.forEach(function (q, i) {
        if (!q || !q.key) return;
        var cs = categorySet(q) || enabledCats.map(function (c) { return clean(c.key); });
        activeOptions(q).forEach(function (o, j) {
          var t = clean(o.tag), found = false;
          cs.forEach(function (ck) { var m = summary[q.key] && summary[q.key][ck]; if (m && m[t]) found = true; });
          if (!found) warn('questions[' + i + '].options[' + j + '].tag', 'no product in ' + cs.join('/') + ' has ' + q.key + ' = "' + o.tag + '"');
        });
        var known = activeOptions(q).map(function (o) { return clean(o.tag); });
        cs.forEach(function (ck) {
          var m = summary[q.key] && summary[q.key][ck];
          if (!m) return;
          Object.keys(m).forEach(function (v) { if (known.indexOf(v) === -1 && !(rules[q.key] && rules[q.key].mode === 'superset' && rules[q.key].covers && coversHas(rules[q.key].covers, v))) warn('questions[' + i + ']', 'products in ' + ck + ' also carry ' + q.key + ' = "' + v + '" which no option offers'); });
        });
      });
    }
    return { errors: errors, warnings: warnings };
  }

  function coversHas(covers, v) {
    for (var k in covers) if (clean(k) === v) return true;
    return false;
  }

  // The set of categories a question can show for, from its category
  // conditions; null when it is not restricted by category.
  function categorySet(q) {
    var conds = (q && q.show_when) || [];
    var set = null;
    for (var i = 0; i < conds.length; i++) {
      var c = conds[i];
      if (!c || c.q !== CATEGORY) continue;
      if (Array.isArray(c['in'])) {
        var s = c['in'].map(clean);
        set = set ? set.filter(function (x) { return s.indexOf(x) !== -1; }) : s;
      }
    }
    return set;
  }

  // { key: { category: { value: count } } } — every value the catalogue
  // actually carries, for the admin's "what can I offer" table.
  function metafieldValueSummary(products) {
    var out = {};
    (products || []).forEach(function (p) {
      var cat = clean(p.category) || '(none)';
      var specs = p.specs || {};
      Object.keys(specs).forEach(function (k) {
        specValues(specs[k]).forEach(function (v) {
          out[k] = out[k] || {};
          out[k][cat] = out[k][cat] || {};
          out[k][cat][v] = (out[k][cat][v] || 0) + 1;
        });
      });
    });
    return out;
  }

  return {
    CATEGORY: CATEGORY,
    MODES: MODES,
    clean: clean,
    specValues: specValues,
    ruleFor: ruleFor,
    evaluateCriterion: evaluateCriterion,
    visibleQuestions: visibleQuestions,
    isVisible: isVisible,
    pruneAnswers: pruneAnswers,
    activeOptions: activeOptions,
    inStock: inStock,
    recommend: recommend,
    validateConfig: validateConfig,
    metafieldValueSummary: metafieldValueSummary,
    categorySet: categorySet
  };
});

// Attribute-based quiz flow (Bodysuit v2): three layers kept apart.
//
//   product attributes  — facts about the product (quiz_product_attributes),
//                          carried on each bundle product as `attrs`
//   answer → constraints — config: which answer filters (HARD) or scores (SOFT)
//                          which attribute. Changing a question = editing config.
//   scoring + routing    — this file: skip_if, forced answers, HARD filter,
//                          ordered relaxation, SOFT ranking, honest near-miss.
//
// Shared by Node (module.exports) and the storefront (window.HSQuizAttr).
//
// Flow config shape (config.flows[category]):
//   { engine: 'attributes', version, enabled, questions[], constraints[],
//     relaxation[], labels{}, why_phrases[], texts{} }
// Question: { id, type: 'single'|'multi', max?, title, layout?, options[{value,label,desc?,hint?,image?}],
//             skip_if?: predicate, forced?: value-when-skipped }
// Predicate: { q, in:[..] } | { q, contains: v } | { q, eq: v } | { all:[..] } | { any:[..] } | { not: p }
// Constraint: { id, q, value?|values?, each?, type:'hard'|'soft', score?, label?, rule }
//   rule: { attr, op, value? } | { all:[rules] } | { any:[rules] }
//   op: eq | ne | in | includes | gte | lte | truthy | falsy | eq_answer | includes_answer
// Relaxation step: { id, when?: predicate, replace?: {q, value}, soften?: constraintId, note }
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.HSQuizAttr = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var ACTION_RANK = { scale: 0, keep: 1, maintain: 2 };
  // A question she skipped («Не впевнена — пропустити»): answered, so the
  // flow moves on and the counter advances, but it asks nothing of the product.
  var SKIP = 'skip';
  function isSkip(v) { var a = arr(v); return a.length === 1 && a[0] === SKIP; }

  function arr(v) { return Array.isArray(v) ? v : (v === undefined || v === null || v === '' ? [] : [v]); }
  function has(list, v) { return arr(list).indexOf(v) !== -1; }

  // ── predicates over answers ───────────────────────────────────────────────
  function evalPredicate(p, answers) {
    if (!p) return true;
    if (Array.isArray(p.all)) return p.all.every(function (x) { return evalPredicate(x, answers); });
    if (Array.isArray(p.any)) return p.any.some(function (x) { return evalPredicate(x, answers); });
    if (p.not) return !evalPredicate(p.not, answers);
    var v = answers ? answers[p.q] : undefined;
    if (v === undefined || v === null || v === '' || (Array.isArray(v) && !v.length)) return false;
    if (Array.isArray(p['in'])) return arr(v).some(function (x) { return p['in'].indexOf(x) !== -1; });
    if (p.contains !== undefined) return has(v, p.contains);
    if (p.eq !== undefined) return Array.isArray(v) ? (v.length === 1 && v[0] === p.eq) : v === p.eq;
    return true;
  }

  function answered(q, answers) {
    var v = answers[q.id];
    return !(v === undefined || v === null || v === '' || (Array.isArray(v) && !v.length));
  }

  // The questions this visitor sees, in order, with skipped ones resolved to
  // their forced value. Returns { visible: [q], forced: {id: value} }.
  function resolveFlow(flow, answers) {
    var visible = [], forced = {};
    (flow.questions || []).forEach(function (q) {
      if (q.enabled === false) return;
      if (q.skip_if && evalPredicate(q.skip_if, answers)) {
        if (q.forced !== undefined) forced[q.id] = q.forced;
        return;
      }
      visible.push(q);
    });
    return { visible: visible, forced: forced };
  }

  // Effective answers: visible answers + forced values; answers to questions
  // that are now skipped are dropped.
  function effectiveAnswers(flow, answers) {
    var r = resolveFlow(flow, answers || {});
    var out = {};
    r.visible.forEach(function (q) { if (answered(q, answers)) out[q.id] = answers[q.id]; });
    Object.keys(r.forced).forEach(function (k) { out[k] = r.forced[k]; });
    if (answers && answers.category) out.category = answers.category;
    return out;
  }

  // Next unanswered question. `order` (question ids) lets an entry path ask
  // in a different sequence — the «Не знаю» path asks body shape last.
  function nextQuestion(flow, answers, order) {
    var r = resolveFlow(flow, answers || {});
    var pending = r.visible.filter(function (q) { return !answered(q, answers || {}); });
    if (!pending.length) return null;
    if (Array.isArray(order)) {
      for (var i = 0; i < order.length; i++) {
        var hit = pending.filter(function (q) { return q.id === order[i]; })[0];
        if (hit) return hit;
      }
    }
    return pending[0];
  }

  // Options of a question that apply to these answers — option.hide_if /
  // option.show_if are predicates over earlier answers (e.g. no ruffles for
  // an apple shape, no one-shoulder for a full bust).
  function visibleOptions(q, answers) {
    return ((q && q.options) || []).filter(function (o) {
      if (!o || o.enabled === false) return false;
      if (o.hide_if && evalPredicate(o.hide_if, answers || {})) return false;
      if (o.show_if && !evalPredicate(o.show_if, answers || {})) return false;
      return true;
    });
  }

  // Step counter that never jumps: the total is every enabled question; every
  // answered or skipped (forced) question counts as passed, whatever the order
  // they were asked in (the «Не знаю» path reorders them).
  function progress(flow, answers) {
    var a = answers || {};
    var all = (flow.questions || []).filter(function (q) { return q.enabled !== false; });
    var passed = 0;
    for (var i = 0; i < all.length; i++) {
      var q = all[i];
      if ((q.skip_if && evalPredicate(q.skip_if, a)) || answered(q, a)) passed++;
    }
    return { index: Math.min(passed + 1, all.length), total: all.length };
  }

  // ── rules over product attributes ─────────────────────────────────────────
  // Three-valued: true / false / null. null = the product does not declare
  // the attribute yet — never a HARD failure and never a SOFT credit, so an
  // incomplete grid degrades to "less certain", not to "nothing matches".
  function isUnknown(a) { return a === undefined || a === null || a === '' || (Array.isArray(a) && !a.length); }
  function evalRule(rule, attrs, answerValue) {
    if (!rule) return true;
    if (Array.isArray(rule.all) || Array.isArray(rule.any)) {
      var list = rule.all || rule.any, anyNull = false, anyTrue = false, anyFalse = false;
      for (var i = 0; i < list.length; i++) {
        var r = evalRule(list[i], attrs, answerValue);
        if (r === null) anyNull = true; else if (r) anyTrue = true; else anyFalse = true;
      }
      if (rule.all) return anyFalse ? false : (anyNull ? null : true);
      return anyTrue ? true : (anyNull ? null : false);
    }
    var a = attrs ? attrs[rule.attr] : undefined;
    if (isUnknown(a)) return null;
    switch (rule.op) {
      case 'eq': return a === rule.value;
      case 'ne': return a !== rule.value;
      case 'in': return arr(rule.value).indexOf(a) !== -1;
      case 'includes': return has(a, rule.value);
      case 'gte': return typeof a === 'number' && a >= rule.value;
      case 'lte': return typeof a === 'number' && a <= rule.value;
      case 'truthy': return !!a && a !== 0 && a !== '0';
      case 'falsy': return !a || a === 0 || a === '0';
      case 'eq_answer': return a === answerValue;
      case 'includes_answer': return has(a, answerValue);
      default: return false;
    }
  }

  // Constraints that apply to these answers: [{ c, value }] — one entry per
  // selected value for `each` constraints.
  function activeConstraints(flow, answers) {
    var out = [];
    (flow.constraints || []).forEach(function (c) {
      var v = answers[c.q];
      if (v === undefined || v === null || v === '' || (Array.isArray(v) && !v.length)) return;
      var vals = arr(v);
      if (isSkip(vals)) return;   // a skipped question constrains nothing
      if (c.value !== undefined && vals.indexOf(c.value) === -1) return;
      if (Array.isArray(c.values) && !vals.some(function (x) { return c.values.indexOf(x) !== -1; })) return;
      // `each` + `values`: one entry per selected value that is in `values` —
      // «просто гладкий силует» must not count as a zone the product misses.
      if (c.each) vals.forEach(function (x) { if ((c.value === undefined || c.value === x) && (!Array.isArray(c.values) || c.values.indexOf(x) !== -1)) out.push({ c: c, value: x }); });
      else out.push({ c: c, value: c.value !== undefined ? c.value : vals[0] });
    });
    return out;
  }

  function actionRank(p) { var r = ACTION_RANK[p.action]; return r === undefined ? 3 : r; }

  // The public bundle carries no margins or decisions: the server sends
  // rank_hint [gate 0|1, pick order] instead, computed from the same fields
  // (quiz-catalog publicProducts), so the storefront ranks identically.
  function hinted(p) { return Array.isArray(p.rank_hint) && p.rank_hint.length === 2; }

  function rank(a, b) {
    if (b.score !== a.score) return b.score - a.score;
    var both = hinted(a.p) && hinted(b.p);
    // Real days of cover first: the safer recommendation among equals.
    var ga = both ? a.p.rank_hint[0] : (a.p.gate_passed ? 0 : 1), gb = both ? b.p.rank_hint[0] : (b.p.gate_passed ? 0 : 1);
    if (ga !== gb) return ga - gb;
    // Fewer unknown attributes = a more certain recommendation.
    var ua = (a.unknown || []).length, ub = (b.unknown || []).length;
    if (ua !== ub) return ua - ub;
    if (both) {
      if (a.p.rank_hint[1] !== b.p.rank_hint[1]) return a.p.rank_hint[1] - b.p.rank_hint[1];
      return (a.p.price || 0) - (b.p.price || 0);
    }
    var ra = actionRank(a.p), rb = actionRank(b.p);
    if (ra !== rb) return ra - rb;
    var ma = a.p.margin_pct == null ? -1 : a.p.margin_pct, mb = b.p.margin_pct == null ? -1 : b.p.margin_pct;
    if (mb !== ma) return mb - ma;
    return (a.p.price || 0) - (b.p.price || 0);
  }

  // A product the team has not described at all (no required attribute
  // filled) is never recommended — better absent than a random guess.
  function eligible(p) {
    if (!p || !p.attrs || p.eligible === false || p.quiz_enabled === false) return false;
    if (typeof p.attrs_filled === 'number') return p.attrs_filled > 0;
    return Object.keys(p.attrs).some(function (k) { var v = p.attrs[k]; return !(v === null || v === undefined || v === '' || (Array.isArray(v) && !v.length)); });
  }

  function evaluate(flow, products, answers, softened) {
    var active = activeConstraints(flow, answers);
    return products.map(function (p) {
      var score = 0, failedHard = [], failedRelaxed = [], matchedHard = [], matchedSoft = [], unknown = [], got = 0, max = 0;
      active.forEach(function (x) {
        var ok = evalRule(x.c.rule, p.attrs, x.value);
        var isHard = x.c.type === 'hard' && !(softened && softened[x.c.id]);
        var w = x.c.weight !== undefined ? x.c.weight : (x.c.type === 'hard' ? 10 : (x.c.score === undefined ? 1 : x.c.score));
        max += w;
        if (ok === null) { unknown.push(x.c); got += w * 0.5; return; }
        if (ok) got += w;
        if (isHard) { if (ok) matchedHard.push(x.c); else failedHard.push(x.c); }
        // A relaxed HARD rule that still fails is remembered: it ranks the
        // product below one that passes it and is named on the card.
        else if (x.c.type === 'hard') { if (ok) matchedHard.push(x.c); else failedRelaxed.push(x.c); }
        else if (ok) { score += (x.c.score === undefined ? 1 : x.c.score); matchedSoft.push(x.c); }
      });
      var pct = max ? Math.round(got / max * 100) : 100;
      return { p: p, score: score, pct: pct, failedHard: failedHard, failedRelaxed: failedRelaxed, matchedHard: matchedHard, matchedSoft: matchedSoft, unknown: unknown };
    });
  }

  // ── the recommendation ────────────────────────────────────────────────────
  // products: bundle products (attrs, eligible, action, margin_pct, price, category)
  // Returns { primary, alternatives, ranked, relaxations:[{id,note}], nearMiss:{unmet:[labels]}|null,
  //           answers (effective), poolSize }
  // opts.count — how many products the result page shows (default 4).
  function recommend(flow, products, rawAnswers, category, opts) {
    opts = opts || {};
    var count = opts.count && opts.count > 0 ? opts.count : 4;
    var answers = effectiveAnswers(flow, rawAnswers || {});
    var cat = category || (rawAnswers && rawAnswers.category);
    var pool = (products || []).filter(function (p) {
      return eligible(p) && (!cat || String(p.category || '').toLowerCase() === String(cat).toLowerCase());
    });
    var fired = [];
    var softened = {};
    var work = Object.assign({}, answers);

    var scored = evaluate(flow, pool, work, softened);
    var ok = scored.filter(function (s) { return !s.failedHard.length; });

    var steps = flow.relaxation || [];
    for (var i = 0; i < steps.length && !ok.length; i++) {
      var st = steps[i];
      if (st.when && !evalPredicate(st.when, work)) continue;
      if (st.replace) work[st.replace.q] = st.replace.value;
      if (st.soften) softened[st.soften] = true;
      fired.push({ id: st.id, note: st.note || '', soften: st.soften || null });
      scored = evaluate(flow, pool, work, softened);
      ok = scored.filter(function (s) { return !s.failedHard.length; });
    }

    // Every candidate is ranked: products that satisfy every HARD rule first
    // (by percent, then soft score and tie-breaks), then the rest by how
    // little they miss. The page shows the top `count`; exact matches read
    // 100%, the others lower — an honest scale, not a hidden cut-off.
    var nearMiss = null;
    scored.sort(function (a, b) {
      var fa = a.failedHard.length ? 1 : 0, fb = b.failedHard.length ? 1 : 0;
      if (fa !== fb) return fa - fb;
      if (a.failedHard.length !== b.failedHard.length) return a.failedHard.length - b.failedHard.length;
      if (a.failedRelaxed.length !== b.failedRelaxed.length) return a.failedRelaxed.length - b.failedRelaxed.length;
      if (b.pct !== a.pct) return b.pct - a.pct;
      return rank(a, b);
    });
    if (!ok.length && scored.length) {
      // Nothing satisfies every rule that may not be relaxed: the closest
      // product leads, and the note says what it misses.
      nearMiss = { unmet: scored[0].failedHard.map(function (c) { return c.label || c.id; }), unmetIds: scored[0].failedHard.map(function (c) { return c.id; }) };
      fired = [];    // none of the relaxations helped — the near-miss note says what is unmet
    }
    // Notes only for relaxations the leading product actually misses — a
    // rule relaxed for the pool but met by the winner is not her problem.
    if (scored.length) {
      var lead = scored[0];
      fired = fired.filter(function (f) { return !f.soften || lead.failedRelaxed.some(function (c) { return c.id === f.soften; }); });
    }
    ok = scored;

    var ranked = ok.map(function (s) {
      var copy = {};
      for (var k in s.p) if (Object.prototype.hasOwnProperty.call(s.p, k)) copy[k] = s.p[k];
      copy.softScore = s.score;
      copy.matchedHard = s.matchedHard.map(function (c) { return c.id; });
      copy.matchedSoft = s.matchedSoft.map(function (c) { return c.id; });
      copy.failedHard = s.failedHard.map(function (c) { return c.id; });
      copy.failedRelaxed = s.failedRelaxed.map(function (c) { return c.id; });
      copy.unknownRules = s.unknown.map(function (c) { return c.id; });
      copy.failedLabels = s.failedHard.concat(s.failedRelaxed).map(function (c) { return c.label || c.id; });
      copy.matchPercent = s.pct;
      copy.exact = !s.failedHard.length && !s.failedRelaxed.length;
      return copy;
    });
    return {
      primary: ranked[0] || null,
      alternatives: ranked.slice(1, count),
      count: count,
      exactCount: ranked.filter(function (p) { return p.exact; }).length,
      ranked: ranked,
      relaxations: fired,
      nearMiss: nearMiss,
      answers: work,
      poolSize: pool.length,
      empty: !ranked.length,
    };
  }

  // ── result-page content ───────────────────────────────────────────────────
  function label(flow, q, value) {
    var L = (flow.labels || {})[q];
    if (L && L[value] !== undefined) return L[value];
    if (value === SKIP) return (flow.texts || {}).skipped || 'пропущено';
    var qq = (flow.questions || []).filter(function (x) { return x.id === q; })[0];
    var o = qq && (qq.options || []).filter(function (x) { return x.value === value; })[0];
    return o ? o.label : String(value || '');
  }

  function fmt(t, vars) {
    return String(t || '').replace(/\{(\w+)\}/g, function (_, k) { return vars[k] !== undefined && vars[k] !== null ? vars[k] : ''; });
  }

  // «Підібрано для тебе: груша · зріст 162–172 · повні груди · помітна корекція на весь день»
  function mirrorLine(flow, answers, product) {
    var t = (flow.texts || {}).mirror || 'Підібрано для тебе: {body_shape} · {height} · {bust} · {effect}{duration_suffix}';
    var a = effectiveAnswers(flow, answers);
    var vars = {};
    Object.keys(a).forEach(function (q) { vars[q] = isSkip(a[q]) ? '' : label(flow, q, Array.isArray(a[q]) ? a[q][0] : a[q]); });
    vars.duration_suffix = a.duration === 'allday' ? ((flow.texts || {}).allday_suffix || ' на весь день') : '';
    vars.product = product ? product.title : '';
    // Skipped answers leave empty slots: drop them and their separators.
    var parts = fmt(t, vars).split(' · ').map(function (x) { return x.trim(); });
    var head = parts.shift() || '';
    var rest = parts.filter(Boolean);
    if (/:$/.test(head)) { if (rest.length) head = head + ' ' + rest.shift(); else head = head.replace(/:$/, ''); }
    return [head].concat(rest).join(' · ');
  }

  // Bullets: first up to `max` from the phrase map (each { when: rule over
  // attrs, needs?: predicate over answers, text }), then the fact lines.
  // Every bullet is { ok: true|false, text } — ✓ or ✕ on the page.
  function whyLines(flow, product, answers, max) {
    var a = effectiveAnswers(flow, answers);
    var active = activeConstraints(flow, a);
    var out = [], cautions = [];
    (flow.why_phrases || []).forEach(function (ph) {
      var neg = ph.ok === false;   // honesty line → ✕, shown after the facts, not capped
      if (!neg && out.length >= (max || 3)) return;
      // { constraint: id } — the line promises exactly what that rule checks:
      // it fires only when the rule is active for her answers and the product
      // meets all of it (never «підтримка грудей» beside «без підтримки грудей»).
      if (ph.constraint) {
        var hits = active.filter(function (x) { return x.c.id === ph.constraint; });
        if (!hits.length) return;
        if (!hits.every(function (x) { return evalRule(x.c.rule, product.attrs, x.value) === true; })) return;
      }
      if (ph.needs && !evalPredicate(ph.needs, a)) return;
      if (ph.when && !evalRule(ph.when, product.attrs, null)) return;
      (neg ? cautions : out).push({ ok: !neg, text: fmt(ph.text, product.attrs || {}) });
    });
    return dedupe(out.concat(factLines(flow, product, a), cautions));
  }

  function dedupe(lines) {
    var seen = {}, out = [];
    lines.forEach(function (l) { var k = String(l.text || '').toLowerCase().replace(/\s+/g, ' ').trim(); if (seen[k]) return; seen[k] = true; out.push(l); });
    return out;
  }

  // ✕ lines for the HARD rules this product fails, or only passes because
  // they were relaxed: the product's value against her answer, in her words.
  // Constraint options: `miss` template ({have}, {want}, plus product attrs),
  // `miss: false` when a fact line already covers it (shape, height).
  function missLines(flow, product, answers) {
    var a = effectiveAnswers(flow, answers);
    var ids = (product.failedHard || []).concat(product.failedRelaxed || []);
    var out = [], seen = {};
    ids.forEach(function (id) {
      if (seen[id]) return; seen[id] = true;
      var c = (flow.constraints || []).filter(function (x) { return x.id === id; })[0];
      if (!c || c.miss === false) return;
      var attrs = product.attrs || {};
      var attrKey = c.rule && c.rule.attr;
      var haveRaw = attrKey ? attrs[attrKey] : undefined;
      var wantRaw = a[c.q]; if (Array.isArray(wantRaw)) wantRaw = wantRaw[0];
      var vars = Object.assign({}, attrs, {
        have: isUnknown(haveRaw) ? '' : label(flow, c.q, Array.isArray(haveRaw) ? haveRaw.join(', ') : haveRaw),
        want: wantRaw === undefined ? '' : label(flow, c.q, wantRaw),
      });
      out.push({ ok: false, text: c.miss ? fmt(c.miss, vars) : ((c.label || c.id) + ' — не збігається') });
    });
    return out;
  }

  // Plain facts from the attributes, config-driven (flow.fact_lines):
  //   { attr, kind: 'set', all: [values], labels: 'body_shape', fits, not_fits, fits_all }
  //   { attr, kind: 'map', map: { value: text } }
  // An empty attribute produces nothing — no line is better than a guess.
  function factLines(flow, product, answers) {
    var at = (product && product.attrs) || {};
    var out = [];
    var FL = (flow.fact_labels || {});
    (flow.fact_lines || []).forEach(function (f) {
      var v = at[f.attr];
      if (v === undefined || v === null || v === '' || (Array.isArray(v) && !v.length)) return;
      if (f.kind === 'map') {
        var txt = f.map && f.map[v];
        if (txt) out.push({ ok: f.ok === undefined ? true : !!f.ok, text: txt });
        return;
      }
      if (f.kind === 'set') {
        var have = arr(v);
        var all = f.all || have;
        var lab = function (x) { var L = FL[f.labels] || {}; return L[x] !== undefined ? L[x] : label(flow, f.labels, x); };
        var fits = all.filter(function (x) { return have.indexOf(x) !== -1; });
        var not = all.filter(function (x) { return have.indexOf(x) === -1; });
        if (!fits.length) return;
        // Her own answer is excluded: one honest ✕, never a ✓ that lists
        // everyone but her.
        var mine = f.q && answers ? answers[f.q] : undefined;
        if (Array.isArray(mine)) mine = mine[0];
        if (mine !== undefined && all.indexOf(mine) !== -1 && have.indexOf(mine) === -1) {
          out.push({ ok: false, text: fmt(f.not_yours || 'Не для твого варіанту ({mine}) — підходить: {list}', { mine: lab(mine), list: fits.map(lab).join(', ') }) });
          return;
        }
        if (!not.length && f.fits_all) { out.push({ ok: true, text: f.fits_all }); return; }
        out.push({ ok: true, text: fmt(f.fits, { list: fits.map(lab).join(', ') }) });
        if (not.length && f.not_fits) out.push({ ok: false, text: fmt(f.not_fits, { list: not.map(lab).join(', ') }) });
      }
    });
    return out;
  }

  function effectLine(flow, product) {
    var at = product.attrs || {};
    if (at.effect_cm_min == null && at.effect_cm_max == null) return '';
    var tx = flow.texts || {};
    var range = at.effect_cm_min != null && at.effect_cm_max != null && at.effect_cm_min !== at.effect_cm_max
      ? at.effect_cm_min + '–' + at.effect_cm_max : String(at.effect_cm_max != null ? at.effect_cm_max : at.effect_cm_min);
    var lvl = at.compression_level;
    var tail = lvl === 'max' ? (tx.effect_tail_max || '')
      : lvl === 'medium' ? (tx.effect_tail_medium || tx.effect_tail || '')
      : (tx.effect_tail !== undefined && tx.effect_tail !== null ? tx.effect_tail : 'Згладжує, не корсет.');
    return fmt(tx.effect || 'Ефект: −{range} см в талії. {tail}', { range: range, tail: tail }).trim();
  }

  // Which model photo to show: larger bands for pear/apple and full bust.
  function photoBand(answers) {
    var a = answers || {};
    var big = a.body_shape === 'pear' || a.body_shape === 'apple';
    var full = a.bust === 'full';
    if (big && full) return '2XL+';
    if (big || full) return 'L–XL';
    return 'S–M';
  }

  function photoFor(product, band) {
    var by = product && product.attrs && product.attrs.photos_by_band;
    if (typeof by === 'string') { try { by = JSON.parse(by); } catch (e) { by = null; } }
    if (by && by[band]) return { url: by[band], band: band, fallback: false };
    return { url: product ? product.image : '', band: band, fallback: true };
  }

  // ── «Не знаю» routing ─────────────────────────────────────────────────────
  // unsure: { t1:{...}, t2:{...}, routing:[{ t1:[..]|'any', t2:[..]|'any', category, prefill }] }
  function routeUnsure(unsure, t1, t2) {
    var rules = (unsure && unsure.routing) || [];
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      var okT1 = r.t1 === 'any' || r.t1 === undefined || arr(r.t1).indexOf(t1) !== -1;
      var okT2 = r.t2 === 'any' || r.t2 === undefined || arr(r.t2).indexOf(t2) !== -1;
      if (okT1 && okT2) return { category: r.category, prefill: r.prefill || {}, rule: i };
    }
    return null;
  }

  // ── validation (admin) ────────────────────────────────────────────────────
  function validateFlow(flow, path) {
    var errors = [], warnings = [];
    var P = path || 'flows.x';
    var ids = {};
    (flow.questions || []).forEach(function (q, i) {
      var p = P + '.questions[' + i + ']';
      if (!q.id) errors.push({ path: p, message: 'question id required' });
      if (ids[q.id]) errors.push({ path: p, message: 'duplicate question id "' + q.id + '"' });
      ids[q.id] = q;
      if (!q.title) errors.push({ path: p + '.title', message: 'title required' });
      var opts = (q.options || []).filter(function (o) { return o && o.value !== undefined && o.label; });
      if (opts.length < 2) errors.push({ path: p + '.options', message: 'at least 2 options with value and label' });
      if (q.type === 'multi' && !(q.max >= 1)) warnings.push({ path: p + '.max', message: 'multi question without max' });
      if (q.skip_if && q.forced === undefined) warnings.push({ path: p, message: 'skip_if without forced value — the answer will simply be missing' });
      if (q.skip_if) checkPredicate(q.skip_if, ids, p + '.skip_if', i, errors);
      (q.options || []).forEach(function (o, j) {
        if (o && o.hide_if) checkPredicate(o.hide_if, ids, p + '.options[' + j + '].hide_if', i, errors);
        if (o && o.show_if) checkPredicate(o.show_if, ids, p + '.options[' + j + '].show_if', i, errors);
      });
    });
    var cids = {};
    (flow.constraints || []).forEach(function (c, i) {
      var p = P + '.constraints[' + i + ']';
      if (!c.id) errors.push({ path: p, message: 'constraint id required' });
      if (cids[c.id]) errors.push({ path: p, message: 'duplicate constraint id "' + c.id + '"' });
      cids[c.id] = true;
      if (!ids[c.q]) errors.push({ path: p + '.q', message: 'unknown question "' + c.q + '"' });
      if (c.type !== 'hard' && c.type !== 'soft') errors.push({ path: p + '.type', message: 'type must be hard or soft' });
      if (!c.rule) errors.push({ path: p + '.rule', message: 'rule required' });
      if (c.value !== undefined && ids[c.q] && !(ids[c.q].options || []).some(function (o) { return o.value === c.value; })) warnings.push({ path: p + '.value', message: 'value "' + c.value + '" is not an option of ' + c.q });
    });
    (flow.relaxation || []).forEach(function (r, i) {
      var p = P + '.relaxation[' + i + ']';
      if (r.soften && !cids[r.soften]) errors.push({ path: p + '.soften', message: 'unknown constraint "' + r.soften + '"' });
      if (r.replace && !ids[r.replace.q]) errors.push({ path: p + '.replace', message: 'unknown question "' + r.replace.q + '"' });
    });
    return { errors: errors, warnings: warnings };
  }

  function checkPredicate(p, ids, path, idx, errors) {
    if (!p) return;
    if (Array.isArray(p.all)) return p.all.forEach(function (x, j) { checkPredicate(x, ids, path + '.all[' + j + ']', idx, errors); });
    if (Array.isArray(p.any)) return p.any.forEach(function (x, j) { checkPredicate(x, ids, path + '.any[' + j + ']', idx, errors); });
    if (p.not) return checkPredicate(p.not, ids, path + '.not', idx, errors);
    if (p.q && !ids[p.q]) errors.push({ path: path, message: 'refers to "' + p.q + '" which is not an earlier question' });
  }

  return {
    evalPredicate: evalPredicate, evalRule: evalRule, resolveFlow: resolveFlow, effectiveAnswers: effectiveAnswers,
    nextQuestion: nextQuestion, progress: progress, visibleOptions: visibleOptions, activeConstraints: activeConstraints, recommend: recommend,
    mirrorLine: mirrorLine, whyLines: whyLines, factLines: factLines, missLines: missLines, effectLine: effectLine, photoBand: photoBand, photoFor: photoFor,
    routeUnsure: routeUnsure, validateFlow: validateFlow, label: label, SKIP: SKIP, isSkip: isSkip,
    actionRank: actionRank,
  };
});

/**
 * HS Quiz v2 — storefront renderer.
 *
 * Published to the live theme as assets/hs-quiz.js by services/theme-sync.js,
 * concatenated after services/quiz-engine.js (window.HSQuizEngine — the
 * tag-matching engine used by most categories) and services/quiz-attr-engine.js
 * (window.HSQuizAttr — the attribute-based engine used by flows such as
 * Bodysuit v2). Everything it shows comes from GET /api/quiz/bundle.
 * No Liquid, no innerHTML — the DOM is built with a small h() helper and
 * textContent, image/link targets are allow-listed.
 *
 *   <div data-hs-quiz data-mode="page" data-api="https://returns.holyshapeua.com"></div>
 *   window.HSQuiz.mount(el, opts) · window.HSQuiz.openModal(opts) · window.HSQuiz.version
 */
(function () {
  'use strict';
  if (window.HSQuiz && window.HSQuiz.__v2) return;
  var Engine = window.HSQuizEngine;
  var Attr = window.HSQuizAttr;
  var SKIPV = (Attr && Attr.SKIP) || 'skip';   // the answer value of a skipped question
  var DEFAULT_API = 'https://returns.holyshapeua.com';
  var STATE_KEY = 'hsq2_state';
  var SESSION_KEY = 'hsq_session';         // shared with the popup, so the funnel joins up

  // ── tiny DOM helper ───────────────────────────────────────────────────────
  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') el.className = v;
      else if (k === 'text') el.textContent = v;
      else if (k === 'style') el.setAttribute('style', v);
      else if (k.indexOf('on') === 0 && typeof v === 'function') el.addEventListener(k.slice(2), v);
      else el.setAttribute(k, v);
    });
    (Array.isArray(children) ? children : (children === undefined ? [] : [children])).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  }
  function svg(tag, attrs, children) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    Object.keys(attrs || {}).forEach(function (k) { el.setAttribute(k, attrs[k]); });
    (children || []).forEach(function (c) { el.appendChild(c); });
    return el;
  }
  function clear(el) { while (el.firstChild) el.removeChild(el.firstChild); }

  function safeImg(url, width) {
    if (!url) return '';
    var s = String(url);
    if (s.indexOf('data:image/svg+xml') === 0) return s;
    if (s.indexOf('//') === 0) s = 'https:' + s;
    // Shopify CDN, the app's own static files (quiz illustrations), or a same-origin path.
    if (!/^https:\/\/cdn\.shopify\.com\//.test(s) && !/^https:\/\/returns\.holyshapeua\.com\//.test(s) && s.charAt(0) !== '/') return '';
    if (width && /^https:\/\/cdn\.shopify\.com\//.test(s)) s += (s.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    return s;
  }
  function safeHref(url, variantId) {
    var s = String(url || '');
    if (s.indexOf('/products/') !== 0) return '#';
    if (variantId) s += (s.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId);
    return s;
  }
  function safeVideo(url) {
    var s = String(url || '');
    if (!/^https:\/\//.test(s)) return null;
    var yt = s.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    if (yt) return { kind: 'iframe', src: 'https://www.youtube-nocookie.com/embed/' + yt[1] };
    var vm = s.match(/vimeo\.com\/(\d+)/);
    if (vm) return { kind: 'iframe', src: 'https://player.vimeo.com/video/' + vm[1] };
    if (/\.(mp4|webm|mov)(\?|$)/i.test(s) || /cdn\.shopify\.com/.test(s)) return { kind: 'video', src: s };
    return { kind: 'link', src: s };
  }
  function fmt(t, vars) {
    return String(t || '').replace(/\{(\w+)\}/g, function (_, k) { return vars[k] !== undefined && vars[k] !== null ? vars[k] : ''; });
  }
  function ss(get, key, val) {
    try { if (get) return sessionStorage.getItem(key); if (val === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, val); } catch (e) { return null; }
  }
  function sessionId() {
    var v = ss(true, SESSION_KEY);
    if (!v) { v = 'q' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12); ss(false, SESSION_KEY, v); }
    return v;
  }
  function isEmpty(v) { return v === undefined || v === null || v === '' || (Array.isArray(v) && !v.length); }

  // Floating third-party widgets that sit on top of the quiz — the Appstle
  // loyalty «Заощаджуй» button and its panel — are hidden from the moment a
  // quiz starts until the modal closes (on the quiz page: for the whole visit).
  var HIDE_WHILE_ACTIVE = ['#appstle-loyalty-button', '.appstle-loyalty-button', '#appstle_loyalty_iframe', '#hs-war-notice-pop'];
  var hideDepth = 0;
  function hideWidgets() {
    hideDepth++;
    if (document.getElementById('hsq-hide-widgets')) return;
    var st = document.createElement('style');
    st.id = 'hsq-hide-widgets';
    st.textContent = HIDE_WHILE_ACTIVE.join(', ') + ' { display: none !important; }';
    (document.head || document.documentElement).appendChild(st);
  }
  function showWidgets() {
    hideDepth = Math.max(0, hideDepth - 1);
    if (hideDepth) return;
    var st = document.getElementById('hsq-hide-widgets');
    if (st && st.parentNode) st.parentNode.removeChild(st);
  }

  // On /pages/quiz the theme's sticky header and rotating announcement bar
  // took 140px of every phone screen and hid the card's own top (Назад, step
  // counter) after each step. The page version now quiets that chrome.
  function quietPage() {
    if (document.getElementById('hsq-quiet-page')) return;
    var st = document.createElement('style');
    st.id = 'hsq-quiet-page';
    // Only the announcement bar is hidden. Forcing the theme's <sticky-header>
    // to position: static made its box cover the quiz and swallow every click,
    // so the header keeps its own positioning; scrollTop() offsets for it.
    st.textContent = '[id^="shopify-section"][id$="__announcement-bar"], .announcement-bar-section, .announcement-bar { display: none !important; }';
    (document.head || document.documentElement).appendChild(st);
  }
  // Height of whatever is still fixed or sticky at the top of the viewport.
  function stickyOffset() {
    var off = 0;
    try {
      var els = document.querySelectorAll('header, [id^="shopify-section"][id*="header"], [id^="shopify-section"][id*="announcement"], .announcement-bar');
      for (var i = 0; i < els.length; i++) {
        var cs = getComputedStyle(els[i]);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
        var rr = els[i].getBoundingClientRect();
        if (rr.height > 0 && rr.height < 300 && rr.top < 200) off = Math.max(off, rr.bottom);
      }
    } catch (e) {}
    return Math.max(0, Math.min(off, 300));
  }
  // ── motion helpers ────────────────────────────────────────────────────────
  function reducedMotion() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }
  // Re-render inside a View Transition when the browser has it: the option
  // she tapped morphs into its chip in the trail above the next question and
  // the rest of the card cross-fades. Otherwise (Firefox, reduced motion) the
  // update is instant.
  function withTransition(update) {
    if (typeof document.startViewTransition === 'function' && !reducedMotion()) {
      try {
        var ran = false;
        var vt = document.startViewTransition(function () { ran = true; update(); });
        // The DOM update waits for the browser's snapshot, which a hidden or
        // struggling tab can delay: after 600ms skip the animation and update anyway.
        setTimeout(function () { if (!ran) { try { vt.skipTransition(); } catch (e) {} if (!ran) { ran = true; update(); } } }, 600);
        return;
      } catch (e) {}
    }
    update();
  }
  function vtName(qid, value) {
    return 'hsq-' + String(qid + '-' + value).replace(/[^A-Za-z0-9_-]/g, '_');
  }
  function focusEl(el) {
    if (!el) return;
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} }
  }

  // ── the quiz ──────────────────────────────────────────────────────────────
  function Quiz(container, opts) {
    opts = opts || {};
    this.el = container;
    this.mode = opts.mode || container.getAttribute('data-mode') || 'page';
    var api = (opts.api || container.getAttribute('data-api') || DEFAULT_API).replace(/\/+$/, '');
    this.bundleUrl = opts.bundleUrl || api + '/api/quiz/bundle';
    this.eventsUrl = opts.eventsUrl || api + '/api/quiz-event';
    this.onClose = opts.onClose || null;
    // Which door opened the quiz (popup / sheet / pill / tile / pdp_line …),
    // what triggered it, the holdout arm and the page type — sent with every
    // event so /quiz can follow each door to the order.
    this.ctx = {};
    var self0 = this;
    ['entry', 'trigger', 'arm', 'page_type'].forEach(function (k) { if (opts[k]) self0.ctx[k] = String(opts[k]).slice(0, 30); });
    // Product paths she opened the quiz from (a product page, or the products
    // of the collection she is browsing): the quiz starts in their category.
    if (!this.ctx.entry && this.mode === 'page') this.ctx.entry = 'page';
    this.fromProducts = Array.isArray(opts.from_products) ? opts.from_products.slice(0, 24) : [];
    this.answers = {};
    this.entry = 'category';                  // 'category' | 'unsure'
    this.unsure = null;                       // { t1, t2 } while in the «не знаю» path
    this.config = null;
    this.products = [];
    this.version = null;
    this.el.classList.add('hsq-root');
  }

  Quiz.prototype.track = function (event, data) {
    try {
      var fl = this.flow();
      var body = Object.assign({
        session: sessionId(), event: event, config_version: this.version, mode: this.mode,
        category: this.answers.category || (this.unsure ? 'unsure' : null),
        quiz_version: fl ? fl.version : (this.answers.category ? 'tags_v2' : null),
      }, this.ctx, data || {});
      var json = JSON.stringify(body);
      if (navigator.sendBeacon) { navigator.sendBeacon(this.eventsUrl, new Blob([json], { type: 'text/plain' })); return; }
      fetch(this.eventsUrl, { method: 'POST', body: json, headers: { 'Content-Type': 'text/plain' }, keepalive: true, mode: 'cors' }).catch(function () {});
    } catch (e) { /* telemetry must never break the quiz */ }
  };

  Quiz.prototype.start = function () {
    var self = this;
    hideWidgets();
    if (this.mode === 'page') quietPage();
    this.renderSkeleton();
    return this.load().then(function (bundle) {
      self.config = bundle.config;
      self.products = bundle.products || [];
      self.version = bundle.version;
      self.applyTheme();
      self.track('open');
      var restored = self.restore();
      if (restored && restored.kind === 'progress') { self.renderStep(); return; }   // mid-quiz reload keeps her answers
      if (restored) { self.renderResultsFor(restored, true); return; }
      var cat = self.categoryFromProducts();
      if (cat) {
        // She came from a product or a collection of one kind: skip «Який тип
        // виробу?» — the trail's category chip lets her change it.
        self.answers = { category: cat.key };
        self.track('start', { step: 1, answer_tag: cat.key, answer: cat.label, question_key: 'category_from_page' });
      }
      self.renderStep();
    }).catch(function (err) {
      self.renderError(err);
      self.track('error', { answer: String(err && err.message || err).slice(0, 200) });
    });
  };

  Quiz.prototype.load = function () {
    var url = this.bundleUrl;
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 12000) : null;
    return fetch(url, { mode: 'cors', signal: ctrl ? ctrl.signal : undefined }).then(function (r) {
      if (!r.ok) throw new Error('bundle ' + r.status);
      return r.json();
    }).then(function (b) {
      if (timer) clearTimeout(timer);
      if (!b || !b.ok || !b.config) throw new Error('bundle malformed');
      return b;
    });
  };

  Quiz.prototype.applyTheme = function () {
    var t = this.config.theme || {};
    var map = { primary: '--hsq-primary', primary_dark: '--hsq-primary-dark', bg: '--hsq-bg', card_bg: '--hsq-card', text: '--hsq-text', text_muted: '--hsq-muted', border: '--hsq-border', selected_bg: '--hsq-selected' };
    var self = this;
    Object.keys(map).forEach(function (k) { if (t[k] && /^#[0-9a-f]{3,8}$/i.test(t[k])) self.el.style.setProperty(map[k], t[k]); });
  };

  // The attribute flow for the current category, when it is switched on and
  // the engine that runs it is present; otherwise null → tag engine.
  Quiz.prototype.flow = function () {
    var cat = this.answers.category;
    if (!cat || !Attr || !this.config || !this.config.flows) return null;
    var f = this.config.flows[cat];
    // ?hsq_flow=1 lets staff try a flow that is still switched off, for this visitor only.
    var force = false; try { force = /[?&]hsq_flow=1/.test(window.location.search); } catch (e) {}
    return f && f.engine === 'attributes' && (f.enabled !== false || force) && (f.questions || []).length ? f : null;
  };

  // The category most of fromProducts belong to (≥60% of those the catalogue
  // knows), when that category is switched on; otherwise null → step 1.
  function normPath(p) {
    var s = String(p || '').split('?')[0].split('#')[0];
    try { s = decodeURIComponent(s); } catch (e) {}
    var m = s.toLowerCase().match(/\/products\/([^/]+)/);
    return m ? m[1] : null;
  }
  Quiz.prototype.categoryFromProducts = function () {
    if (!this.fromProducts.length || !this.config) return null;
    var byHandle = {};
    this.products.forEach(function (p) { var hd = normPath(p.url); if (hd && p.category) byHandle[hd] = p.category; });
    var votes = {}, known = 0;
    this.fromProducts.forEach(function (u) { var c = byHandle[normPath(u)]; if (c) { votes[c] = (votes[c] || 0) + 1; known++; } });
    if (!known) return null;
    var best = null;
    Object.keys(votes).forEach(function (k) { if (!best || votes[k] > votes[best]) best = k; });
    if (votes[best] / known < 0.6) return null;
    var cats = this.config.categories || [];
    for (var i = 0; i < cats.length; i++) {
      if (cats[i].key === best && cats[i].enabled !== false && cats[i].label) return { key: best, label: cats[i].label };
    }
    return null;
  };

  // ── state ─────────────────────────────────────────────────────────────────
  Quiz.prototype.persist = function (kind) {
    ss(false, STATE_KEY, JSON.stringify({ v: this.version, kind: kind, answers: this.answers, entry: this.entry, unsure: this.unsure }));
  };
  Quiz.prototype.restore = function () {
    try {
      var raw = ss(true, STATE_KEY);
      if (!raw) return null;
      var st = JSON.parse(raw);
      if (!st || st.v !== this.version || !st.kind || !st.answers || !st.answers.category) return null;
      this.answers = st.answers; this.entry = st.entry || 'category'; this.unsure = st.unsure || null;
      if (st.kind === 'progress') return { kind: 'progress' };
      return this.compute();
    } catch (e) { return null; }
  };
  Quiz.prototype.reset = function () {
    this.answers = {}; this.entry = 'category'; this.unsure = null;
    ss(false, STATE_KEY, null);
  };

  // Tag engine helpers (legacy categories)
  Quiz.prototype.visible = function () { return Engine.visibleQuestions(this.config, this.answers); };
  Quiz.prototype.answered = function () {
    var a = this.answers;
    return this.visible().filter(function (q) { return !isEmpty(a[q.key]); });
  };
  Quiz.prototype.categoryLabel = function () {
    var key = this.answers.category, cats = this.config.categories || [];
    for (var i = 0; i < cats.length; i++) if (Engine.clean(cats[i].key) === Engine.clean(key)) return cats[i].label;
    return key || '';
  };
  Quiz.prototype.longestPath = function () {
    var cfg = this.config, max = 0, self = this;
    (cfg.categories || []).forEach(function (c) {
      if (c.enabled === false || !c.key) return;
      var f = cfg.flows && cfg.flows[c.key];
      var n = (Attr && f && f.engine === 'attributes' && f.enabled !== false) ? Attr.resolveFlow(f, { category: c.key }).visible.length : Engine.visibleQuestions(cfg, { category: c.key }).length;
      if (n > max) max = n;
    });
    return max;
  };

  // Compute the result for the current answers with whichever engine applies.
  Quiz.prototype.compute = function () {
    var fl = this.flow();
    if (fl) return { kind: 'attr', flow: fl, res: Attr.recommend(fl, this.products, this.answers, this.answers.category, { count: (this.config.results && this.config.results.count) || 4 }) };
    return { kind: 'tags', res: Engine.recommend(this.config, this.products, this.answers) };
  };

  // ── rendering: shared bits ────────────────────────────────────────────────
  Quiz.prototype.scrollTop = function () {
    try {
      var host = this.mode === 'modal' ? this.el.closest('.hsq-modal__dialog') : null;
      if (host) { host.scrollTop = 0; return; }
      var r = this.el.getBoundingClientRect();
      var off = stickyOffset();
      if (r.top < off) window.scrollTo({ top: window.pageYOffset + r.top - 16 - off, behavior: 'smooth' });
    } catch (e) {}
  };

  Quiz.prototype.renderSkeleton = function () {
    clear(this.el);
    this.el.appendChild(h('div', { class: 'hsq-card hsq-skel' }, [
      h('div', { class: 'hsq-skel__bar' }), h('div', { class: 'hsq-skel__title' }),
      h('div', { class: 'hsq-skel__opt' }), h('div', { class: 'hsq-skel__opt' }), h('div', { class: 'hsq-skel__opt' }),
    ]));
  };

  Quiz.prototype.renderError = function (err) {
    var self = this;
    var t = (this.config && this.config.texts) || {};
    clear(this.el);
    this.el.appendChild(h('div', { class: 'hsq-card hsq-error' }, [
      h('p', { text: t.error || 'Не вдалося завантажити квіз. Спробуй оновити сторінку.' }),
      h('div', { class: 'hsq-error__actions' }, [
        h('button', { type: 'button', class: 'hsq-btn', text: 'Спробувати ще раз', onclick: function () { self.start(); } }),
        this.mode === 'modal' ? h('a', { class: 'hsq-link', href: '/pages/quiz', text: 'Відкрити сторінку квізу' }) : null,
      ]),
    ]));
  };

  // One question card. spec: { title, eyebrow, options[{label,desc,hint,image,tag}], layout, multi, max, selected:[tags], index, total, showBack, hintText }
  // onPick(tag, btn) for single; for multi the card manages a selection and calls onDone(tags).
  var hintSeq = 0;
  Quiz.prototype.renderQuestion = function (spec, onPick, onDone) {
    var self = this, t = this.config.texts || {};
    var layout = spec.layout || 'list';
    var hasImages = spec.options.some(function (o) { return o.image; });
    if (hasImages && layout === 'list') layout = 'grid';
    var selected = (spec.selected || []).slice();
    var nextBtn = null, errEl = null;

    var opts = spec.options.map(function (o) {
      var img = safeImg(o.image, 600);
      var isSel = selected.indexOf(o.tag) !== -1;
      var hintBox = o.hint ? h('span', { class: 'hsq-opt__hinttext', id: 'hsq-hint-' + (++hintSeq), text: o.hint, hidden: true }) : null;
      var hint = o.hint ? h('button', { type: 'button', class: 'hsq-opt__hint', 'aria-label': (t.hint || 'Підказка') + ': ' + o.label, 'aria-expanded': 'false', 'aria-controls': hintBox.id, text: '?' }) : null;
      var btn = h('button', { type: 'button', class: 'hsq-opt' + (isSel ? ' is-selected' : '') + (spec.multi ? ' hsq-opt--multi' : ''), 'data-tag': o.tag, role: spec.multi ? 'checkbox' : 'radio', 'aria-checked': isSel ? 'true' : 'false' }, [
        img ? h('span', { class: 'hsq-opt__media' + (img.indexOf('data:') === 0 ? ' hsq-opt__media--fit' : '') }, [h('img', { src: img, alt: o.label, loading: 'lazy' })]) : null,
        h('span', { class: 'hsq-opt__body' }, [
          h('span', { class: 'hsq-opt__label', text: o.label }),
          o.desc ? h('span', { class: 'hsq-opt__desc', text: o.desc }) : null,
          hintBox,
        ]),
        h('span', { class: 'hsq-opt__check' }, [tick()]),
      ]);
      if (hint) hint.addEventListener('click', function () { hintBox.hidden = !hintBox.hidden; hint.setAttribute('aria-expanded', hintBox.hidden ? 'false' : 'true'); });
      btn.addEventListener('click', function () {
        if (!spec.multi) {
          var sib = btn.closest('.hsq-opts');
          if (sib) sib.querySelectorAll('.hsq-opt').forEach(function (b) { b.setAttribute('aria-checked', 'false'); b.style.viewTransitionName = ''; });
          btn.setAttribute('aria-checked', 'true');
          if (spec.qid) btn.style.viewTransitionName = vtName(spec.qid, o.tag);
          onPick(o.tag, btn, o); return;
        }
        var i = selected.indexOf(o.tag);
        if (i !== -1) { selected.splice(i, 1); btn.classList.remove('is-selected'); btn.setAttribute('aria-checked', 'false'); }
        else {
          if (spec.max && selected.length >= spec.max) { if (errEl) errEl.textContent = fmt(t.max_reached || 'Можна обрати не більше {max}.', { max: spec.max }); return; }
          selected.push(o.tag); btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true');
        }
        if (errEl) errEl.textContent = '';
      });
      return hint ? h('div', { class: 'hsq-optwrap' }, [btn, hint]) : btn;
    });

    var card = h('div', { class: 'hsq-card hsq-step' + (layout === 'grid' ? ' hsq-step--wide' : '') }, [
      h('div', { class: 'hsq-top' }, [
        h('button', { type: 'button', class: 'hsq-back', style: spec.showBack ? null : 'visibility:hidden', onclick: function () { self.back(); } }, [arrowLeft(), ' ' + (t.back || 'Назад')]),
        h('span', { class: 'hsq-stepno', 'aria-live': 'polite', text: spec.total ? fmt(t.step_of || 'Крок {n} з {total}', { n: spec.index, total: spec.total }) : fmt(t.step_n || 'Крок {n}', { n: spec.index }) }),
      ]),
      h('div', { class: 'hsq-progress', role: 'progressbar', 'aria-valuemin': '0', 'aria-valuemax': String(spec.total || 100), 'aria-valuenow': String(spec.total ? spec.index : Math.round((spec.progress || 0) * 100)) }, [
        h('i', { style: 'width:' + Math.round((spec.total ? spec.index / Math.max(spec.total, 1) : (spec.progress || 0)) * 100) + '%' }),
      ]),
      h('h2', { class: 'hsq-q', id: 'hsq-q-title', text: spec.title }),
      spec.hintText ? h('p', { class: 'hsq-q__sub', text: spec.hintText }) : null,
      spec.lead || null,
      h('div', { class: 'hsq-opts hsq-opts--' + layout, role: spec.multi ? 'group' : 'radiogroup', 'aria-labelledby': 'hsq-q-title' }, opts),
    ]);
    // «Не впевнена — пропустити»: a quiet text button, not an option, so it
    // never reads as one more answer. Sits above the sticky Next row on phones.
    var skipBtn = null;
    if (spec.onSkip) {
      skipBtn = h('button', { type: 'button', class: 'hsq-skip', text: spec.skipText || 'Не впевнена — пропустити', onclick: function () {
        if (spec.qid) skipBtn.style.viewTransitionName = vtName(spec.qid, SKIPV);
        spec.onSkip();
      } });
      // Multi questions carry it inside the (sticky) Next row instead.
      if (!spec.multi) card.appendChild(h('div', { class: 'hsq-skip__row' }, [skipBtn]));
    }
    if (spec.multi) {
      errEl = h('p', { class: 'hsq-next__err', 'aria-live': 'polite' });
      nextBtn = h('button', { type: 'button', class: 'hsq-btn hsq-next', text: spec.nextText || 'Далі', onclick: function () {
        if (selected.length) {
          if (spec.qid) card.querySelectorAll('.hsq-opt.is-selected').forEach(function (b) { b.style.viewTransitionName = vtName(spec.qid, b.getAttribute('data-tag')); });
          onDone(selected.slice()); return;
        }
        errEl.textContent = t.pick_one || 'Обери хоча б один варіант, щоб продовжити.';
      } });
      card.appendChild(h('div', { class: 'hsq-next__row' }, [skipBtn, errEl, nextBtn]));
    }
    if (spec.footer) card.appendChild(spec.footer);
    clear(this.el);
    this.el.appendChild(card);
    focusEl(card.querySelector('.hsq-q'));   // keyboard and screen-reader users land on the new question, not on <body>
    this.scrollTop();
  };

  // ── rendering: steps ──────────────────────────────────────────────────────
  Quiz.prototype.renderStep = function () {
    var self = this, cfg = this.config, t = cfg.texts || {};
    if (this.unsure && !this.answers.category) return this.renderUnsure();
    if (!this.answers.category) {
      var cats = (cfg.categories || []).filter(function (c) { return c.enabled !== false && c.key && c.label; });
      var un = cfg.unsure && cfg.unsure.enabled !== false && cfg.unsure.t1 && cfg.unsure.t2 ? cfg.unsure : null;
      var footer = un ? h('div', { class: 'hsq-unsure' }, [
        h('button', { type: 'button', class: 'hsq-unsure__btn', onclick: function () { self.unsure = {}; self.entry = 'unsure'; self.renderStep(); } }, [
          h('span', { class: 'hsq-unsure__label', text: un.label || 'Не знаю — підбери за мене' }),
          un.desc ? h('span', { class: 'hsq-unsure__desc', text: un.desc }) : null,
        ]),
      ]) : null;
      return this.renderQuestion({
        title: (cfg.category_question && cfg.category_question.title) || 'Який тип виробу ти шукаєш?',
        eyebrow: (cfg.category_question && cfg.category_question.eyebrow) || '',
        layout: (cfg.category_question && cfg.category_question.layout) || 'list',
        options: cats.map(function (c) { return { label: c.label, desc: c.desc, image: c.image, tag: c.key }; }),
        index: 1, total: 1 + this.longestPath(), showBack: false, footer: footer, qid: 'category',
      }, function (tag, btn, o) {
        btn.closest('.hsq-opts').querySelectorAll('.hsq-opt').forEach(function (b) { b.classList.remove('is-selected'); }); btn.classList.add('is-selected');
        setTimeout(function () {
          self.answers = { category: tag };
          self.track('start', { step: 1, answer_tag: tag, answer: o.label });
          withTransition(function () { self.renderStep(); });
        }, 220);
      });
    }

    var fl = this.flow();
    if (fl) return this.renderAttrStep(fl);

    // Tag engine
    var q = null, vis = this.visible(), a = this.answers;
    for (var i = 0; i < vis.length; i++) if (isEmpty(a[vis[i].key])) { q = vis[i]; break; }
    if (!q) return this.finish();
    var rules = cfg.rules || {};
    this.renderQuestion({
      title: q.title, eyebrow: q.eyebrow || (rules[q.key] && rules[q.key].label) || '', layout: q.layout,
      options: Engine.activeOptions(q).map(function (o) { return { label: o.label, desc: o.desc, image: o.image, tag: o.tag }; }),
      selected: isEmpty(a[q.key]) ? [] : [a[q.key]],
      index: 2 + vis.indexOf(q), total: 1 + vis.length, showBack: true,
    }, function (tag, btn, o) {
      btn.closest('.hsq-opts').querySelectorAll('.hsq-opt').forEach(function (b) { b.classList.remove('is-selected'); }); btn.classList.add('is-selected');
      if (self._busy) return; self._busy = true;
      setTimeout(function () {
        self._busy = false;
        self.answers[q.key] = tag;
        self.answers = Engine.pruneAnswers(cfg, self.answers);
        self.track('answer', { question_key: q.key, question: q.title, answer_tag: tag, answer: o.label, step: 2 + vis.indexOf(q) });
        self.renderStep();
      }, 220);
    });
  };

  Quiz.prototype.renderAttrStep = function (fl) {
    var self = this, a = this.answers;
    var q = Attr.nextQuestion(fl, a, this.entry === 'unsure' && fl.unsure_order ? fl.unsure_order : null);
    if (!q) return this.finish();
    this.persist('progress');
    var pr = Attr.progress(fl, a);
    var tx = fl.texts || {};
    var opts = (Attr.visibleOptions ? Attr.visibleOptions(q, a) : (q.options || [])).filter(function (o) { return o && o.value !== undefined && o.label; }).map(function (o) { return { label: o.label, desc: o.desc, hint: o.hint, image: o.image, tag: o.value }; });
    var multi = q.type === 'multi';
    // After «Не знаю» some answers were assumed for her — say so on the first
    // question she actually sees.
    // The trail: every answer so far (the category, her picks, and anything
    // «Не знаю» assumed for her) as a chip above the question. The option she
    // tapped morphs into its chip; tapping a chip reopens that question.
    var lead = this.renderTrail(fl, a);
    var pre = (this.entry === 'unsure' && this.unsure && this.unsure.prefilled ? this.unsure.prefilled : []).filter(function (k) { return !isEmpty(a[k]); });
    // Counter: category path counts the category as step 1. «Не знаю» path is
    // its own 2-step intro, then the flow counts only the questions she will
    // actually answer (prefilled ones are left out) — the total never jumps.
    var off = 1, skipTotal = 0;
    if (this.entry === 'unsure') {
      off = 2;   // the two «Не знаю» questions count as steps 1 and 2
      skipTotal = pre.length;
    }
    var done = function (values, label) {
      a[q.id] = multi ? values : values[0];
      self.answers = a;
      self.track('answer', { question_key: q.id, question: q.title, answer_tag: values.join(','), answer: label, step: pr.index });
      withTransition(function () { self.renderStep(); });
    };
    this.renderQuestion({
      title: q.title, eyebrow: q.eyebrow || '', layout: q.layout, options: opts, multi: multi, max: q.max || null, qid: q.id,
      hintText: q.note || (multi ? fmt(tx.pick_up_to || 'Можна обрати до {max}', { max: q.max || opts.length }) : ''),
      lead: lead,
      nextText: tx.next || 'Далі',
      skipText: tx.skip || 'Не впевнена — пропустити',
      onSkip: q.skippable ? function () {
        if (self._busy) return; self._busy = true;
        a[q.id] = SKIPV; self.answers = a;
        self.track('answer', { question_key: q.id, question: q.title, answer_tag: SKIPV, answer: tx.skipped || 'пропущено', step: pr.index });
        self._busy = false;
        withTransition(function () { self.renderStep(); });
      } : null,
      selected: isEmpty(a[q.id]) ? [] : (Array.isArray(a[q.id]) ? a[q.id] : [a[q.id]]),
      index: pr.index + off - skipTotal, total: pr.total + off - skipTotal, showBack: true,   // prefilled answers are counted by progress(); leave them out on both sides
    }, function (tag, btn, o) {
      btn.closest('.hsq-opts').querySelectorAll('.hsq-opt').forEach(function (b) { b.classList.remove('is-selected'); }); btn.classList.add('is-selected');
      if (self._busy) return; self._busy = true;
      setTimeout(function () { self._busy = false; done([tag], o.label); }, 220);
    }, function (values) {
      var labels = values.map(function (v) { var o = opts.filter(function (x) { return x.tag === v; })[0]; return o ? o.label : v; }).join(', ');
      done(values, labels);
    });
  };

  // «Не знаю — підбери за мене»: two questions, then route to a category
  // with pre-filled answers.
  // Chips for every answer given so far, in flow order, category first.
  Quiz.prototype.renderTrail = function (fl, a) {
    var self = this, tx = fl.texts || {};
    var chips = [];
    var chip = function (qid, value, label, title, onEdit) {
      return h('button', { type: 'button', class: 'hsq-chip on hsq-trail__chip', style: 'view-transition-name: ' + vtName(qid, value), 'aria-label': (tx.change_answer || 'Змінити') + ': ' + title, onclick: function () { onEdit(); withTransition(function () { self.renderStep(); }); } }, [
        h('span', { text: label }), pencil(),
      ]);
    };
    if (a.category) chips.push(chip('category', a.category, this.categoryLabel(), (this.config.category_question && this.config.category_question.title) || 'Категорія', function () { self.answers = {}; self.entry = 'category'; self.unsure = null; }));
    (fl.questions || []).forEach(function (q) {
      if (isEmpty(a[q.id])) return;
      (Array.isArray(a[q.id]) ? a[q.id] : [a[q.id]]).forEach(function (v) {
        var o = (q.options || []).filter(function (x) { return x.value === v; })[0];
        chips.push(chip(q.id, v, (o ? o.label : (Attr && Attr.label ? Attr.label(fl, q.id, v) : String(v))).toLowerCase(), q.title, function () { delete self.answers[q.id]; }));
      });
    });
    if (!chips.length) return null;
    return h('div', { class: 'hsq-trail', role: 'list', 'aria-label': tx.trail || 'Твої відповіді — натисни, щоб змінити' }, chips);
  };

  Quiz.prototype.renderUnsure = function () {
    var self = this, un = this.config.unsure, u = this.unsure;
    var stage = isEmpty(u.t1) ? un.t1 : un.t2;
    var idx = isEmpty(u.t1) ? 1 : 2;
    this.renderQuestion({
      title: stage.title, eyebrow: '', options: (stage.options || []).map(function (o) { return { label: o.label, desc: o.desc, tag: o.value }; }),
      selected: [], index: idx, total: null, progress: idx / (2 + this.longestPath()), showBack: true,   // «Крок 1», «Крок 2», then the flow continues the count
    }, function (tag, btn, o) {
      btn.closest('.hsq-opts').querySelectorAll('.hsq-opt').forEach(function (b) { b.classList.remove('is-selected'); }); btn.classList.add('is-selected');
      if (self._busy) return; self._busy = true;
      setTimeout(function () {
        self._busy = false;
        if (idx === 1) {
          u.t1 = tag;
          self.track('answer', { question_key: 't1', question: stage.title, answer_tag: tag, answer: o.label, step: 1, category: 'unsure' });
          self.renderStep(); return;
        }
        u.t2 = tag;
        self.track('answer', { question_key: 't2', question: stage.title, answer_tag: tag, answer: o.label, step: 2, category: 'unsure' });
        var route = Attr ? Attr.routeUnsure(un, u.t1, u.t2) : null;
        var cat = route && route.category;
        var hasCat = (self.config.categories || []).some(function (c) { return c.key === cat && c.enabled !== false; });
        if (!cat || !hasCat) cat = ((self.config.categories || []).filter(function (c) { return c.enabled !== false; })[0] || {}).key;
        self.answers = { category: cat };
        var fl = self.flow();
        u.prefilled = [];
        if (fl && route && route.prefill) {
          Object.keys(route.prefill).forEach(function (k) {
            var q = (fl.questions || []).filter(function (x) { return x.id === k; })[0];
            if (!q) return;
            var v = route.prefill[k];
            self.answers[k] = q.type === 'multi' ? (Array.isArray(v) ? v : [v]) : (Array.isArray(v) ? v[0] : v);
            u.prefilled.push(k);
          });
        }
        self.track('start', { step: 1, answer_tag: cat, answer: 'unsure:' + u.t1 + '/' + u.t2, category: 'unsure' });
        self.renderStep();
      }, 220);
    });
  };

  Quiz.prototype.back = function () {
    var a = this.answers;
    if (this.unsure && !a.category) {
      if (!isEmpty(this.unsure.t1)) { delete this.unsure.t1; } else { this.unsure = null; this.entry = 'category'; }
      return this.renderStep();
    }
    var fl = this.flow();
    if (fl) {
      var vis = Attr.resolveFlow(fl, a).visible.filter(function (q) { return !isEmpty(a[q.id]); });
      if (vis.length) delete a[vis[vis.length - 1].id];
      else { this.answers = {}; if (this.entry === 'unsure') { this.unsure = { t1: this.unsure && this.unsure.t1 }; } }
      return this.renderStep();
    }
    var done = this.answered();
    if (done.length) delete a[done[done.length - 1].key];
    else { this.answers = {}; if (this.entry === 'unsure') this.unsure = { t1: this.unsure && this.unsure.t1 }; }
    if (this.answers.category) this.answers = Engine.pruneAnswers(this.config, this.answers);
    this.renderStep();
  };

  Quiz.prototype.finish = function () {
    var self = this, r = this.config.results || {}, t = this.config.texts || {};
    var out = this.compute();
    // The wait is truthful: the loader names what is being checked — her
    // answers, not generic phrases — when the attribute flow is running.
    var phrases = (r.loader_phrases && r.loader_phrases.length) ? r.loader_phrases : [t.loading || 'Дивимось твої відповіді…'];
    if (out.kind === 'attr' && Attr && out.res && out.res.answers) {
      var fl = out.flow, an = out.res.answers, own = [];
      var L = function (q) { var v = an[q]; if (Array.isArray(v)) v = v[0]; return isEmpty(v) || v === SKIPV ? null : Attr.label(fl, q, v); };
      var hgt = L('height'), eff = L('effect'), shp = an.body_shape && an.body_shape !== 'unsure' ? L('body_shape') : null;
      if (hgt) own.push(fmt(fl.texts && fl.texts.loader_height || 'Звіряємо {v}…', { v: hgt }));
      if (eff) own.push(fmt(fl.texts && fl.texts.loader_effect || 'Утяжка «{v}» — шукаємо…', { v: eff }));
      if (shp) own.push(fmt(fl.texts && fl.texts.loader_shape || 'Фігура «{v}» — перевіряємо посадку…', { v: shp }));
      own.push((fl.texts && fl.texts.loader_final) || 'Обираємо найкращі варіанти…');
      if (own.length >= 2) phrases = own;
    }
    var totalMs = typeof r.loader_ms === 'number' ? r.loader_ms : 1800;
    var text = h('p', { class: 'hsq-loader__text', text: phrases[0] });
    clear(this.el);
    this.el.appendChild(h('div', { class: 'hsq-card hsq-loader' }, [h('div', { class: 'hsq-loader__ring' }), text]));
    this.scrollTop();
    var i = 0, stepMs = Math.max(250, Math.round(totalMs / phrases.length));
    var timer = setInterval(function () {
      i++;
      if (i < phrases.length) text.textContent = phrases[i];
      else { clearInterval(timer); self.renderResultsFor(out, false); }
    }, stepMs);
  };

  Quiz.prototype.renderResultsFor = function (out, restored) {
    if (out.kind === 'attr') return this.renderAttrResults(out.flow, out.res, restored);
    return this.renderResults(out.res, restored);
  };

  Quiz.prototype.trackFinishOnce = function (data) {
    var finKey = 'hsq_fin_' + sessionId();
    if (ss(true, finKey)) return;
    ss(false, finKey, '1');
    try { localStorage.setItem('hsq_done', String(Date.now())); } catch (e) {}   // the invite stops asking
    this.track('finish', data);
  };

  // Product open → tracked once per product per session; on the attribute
  // flow the session id also goes into the cart so it lands on the order.
  // Best-effort: write the quiz session onto the Shopify cart so an order
  // placed later in this browser joins this run — whether she opens a card
  // here or reaches the product some other way. Never blocks anything.
  function setCartAttr(onDone) {
    var cb = function () { if (onDone) { var f = onDone; onDone = null; f(); } };
    try {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { quiz_session_id: sessionId() } }), keepalive: true })
        .then(cb, cb);
    } catch (err) { cb(); }
  }

  Quiz.prototype.bindClicks = function (root, withCartAttr) {
    var self = this;
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-pid]');
      if (!a) return;
      var pid = a.getAttribute('data-pid');
      var k = 'hsq_clk_' + sessionId() + '_' + pid;
      if (!ss(true, k)) { ss(false, k, '1'); self.track('click', { product_id: pid, product_title: a.getAttribute('data-title') || null }); }
      if (!withCartAttr) return;
      e.preventDefault();
      var href = a.getAttribute('href');
      var go = function () { window.location.href = href; };
      var done = false, finish = function () { if (!done) { done = true; go(); } };
      setTimeout(finish, 700);
      setCartAttr(finish);
    });
  };

  // ── results: attribute flow (spec §5) ─────────────────────────────────────
  Quiz.prototype.renderAttrResults = function (fl, res, restored) {
    var self = this, tx = fl.texts || {}, t = this.config.texts || {};
    this.persist('attr');
    var p = res.primary;
    var retakeLabel = String(t.retake || 'Пройти тест заново').replace('↺', '').trim();

    if (!restored) {
      setCartAttr();   // she has seen a recommendation: any order from this browser now counts
      this.trackFinishOnce({
        product_id: p ? String(p.id) : null, product_title: p ? p.title : null,
        match_pct: p && typeof p.matchPercent === 'number' ? p.matchPercent : null,
        is_fallback: (res.nearMiss || res.relaxations.length) ? 1 : 0,
        result_count: res.ranked.length, answers: res.answers, relaxations: res.relaxations.map(function (r) { return r.id; }),
      });
    }

    var body = [];
    if (!p) {
      body.push(h('div', { class: 'hsq-celebrate', text: t.empty_category_title || 'У цій категорії зараз немає моделей у наявності.' }));
    } else {
      var band = Attr.photoBand(res.answers);
      var photo = Attr.photoFor(p, band);
      if (photo.fallback && !restored) {
        var pk = 'hsq_ph_' + sessionId() + '_' + p.id;
        if (!ss(true, pk)) { ss(false, pk, '1'); this.track('photo_missing', { product_id: String(p.id), product_title: p.title, answer: band }); }
      }
      var fa = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
      var href = safeHref(p.url, fa ? fa.id : null);
      var why = Attr.whyLines(fl, p, res.answers, 3).map(function (w) { return typeof w === 'string' ? { ok: true, text: w } : w; });
      var whyOk = why.filter(function (w) { return w.ok !== false; });
      // ✕ block: every failed or relaxed hard rule (product value vs her answer), then the fact ✕ lines.
      var seenNo = {};
      var whyNo = (Attr.missLines ? Attr.missLines(fl, p, res.answers) : []).concat(why.filter(function (w) { return w.ok === false; }))
        .filter(function (w) { var k = String(w.text).toLowerCase(); if (seenNo[k]) return false; seenNo[k] = true; return true; });
      var closest = !!res.nearMiss || p.exact === false;   // anything relaxed or failed → «Найближчий варіант», never «Найкращий збіг»
      var notFor = whyNo.length ? h('div', { class: 'hsq-notfor' + (closest ? ' hsq-notfor--lead' : '') }, [
        h('p', { class: 'hsq-notfor__title', text: closest ? (tx.differs_title || 'Що відрізняється від твого запиту:') : (tx.not_for_title || 'Кому може не підійти:') }),
        h('ul', { class: 'hsq-why hsq-why--no' }, whyNo.map(function (w, i) { return h('li', { class: 'is-no', style: '--i:' + Math.min(i, 7) }, [h('i', { text: '✕' }), h('span', { text: w.text })]); })),
      ]) : null;
      // «Змінити» chips: reopen just the question behind a relaxed or unmet rule.
      var changeQs = [], seenQ = {};
      var addQ = function (qid) { if (!qid || seenQ[qid]) return; seenQ[qid] = true; var qq = (fl.questions || []).filter(function (x) { return x.id === qid; })[0]; if (qq) changeQs.push(qq); };
      var cById = function (id) { return (fl.constraints || []).filter(function (c) { return c.id === id; })[0]; };
      (res.relaxations || []).forEach(function (r) { var c = r.soften ? cById(r.soften) : null; if (c) addQ(c.q); if (r.replace) addQ(r.replace.q); });
      ((res.nearMiss && res.nearMiss.unmetIds) || []).forEach(function (id) { var c = cById(id); if (c) addQ(c.q); });
      var changeRow = changeQs.length ? h('div', { class: 'hsq-note__actions' }, changeQs.map(function (qq) {
        var v = res.answers[qq.id]; if (Array.isArray(v)) v = v[0];
        var o = (qq.options || []).filter(function (x) { return x.value === v; })[0];
        return h('button', { type: 'button', class: 'hsq-chip hsq-chip--edit', 'aria-label': (tx.change_answer || 'Змінити') + ': ' + qq.title, onclick: function () { delete self.answers[qq.id]; self.renderStep(); } }, [
          h('span', { text: (tx.change_answer || 'Змінити') + ': ' + (o ? o.label.toLowerCase() : qq.title) }), pencil(),
        ]);
      })) : null;
      var eff = Attr.effectLine(fl, p);
      var video = p.attrs && p.attrs.easy_to_put_on === 0 && p.attrs.how_to_wear_video ? safeVideo(p.attrs.how_to_wear_video) : null;
      var img = safeImg(photo.url, 900);

      body.push(h('h2', { class: 'hsq-mirror' }, [Attr.mirrorLine(fl, res.answers, p), ' → ', h('b', { text: p.title })]));   // the results screen's heading: her answers, then the model
      if (res.nearMiss) body.push(h('div', { class: 'hsq-note hsq-note--warn' }, [h('span', { text: 'ⓘ' }), h('div', {}, [h('p', { text: fmt(tx.near_miss || 'Точного збігу немає — ось найближчий варіант. Що саме відрізняється — нижче.', { unmet: res.nearMiss.unmet.join(', ') }) }), changeRow])]));
      else if (res.relaxations.length) body.push(h('div', { class: 'hsq-note' }, [h('span', { text: 'ⓘ' }), h('div', {}, [h('p', { text: (tx.relaxed_prefix || 'Зверни увагу: ') + res.relaxations.map(function (r) { return r.note; }).filter(Boolean).join('; ') }), changeRow])]));

      body.push(h('div', { class: 'hsq-primary' }, [
        h('a', { class: 'hsq-primary__media', href: href, 'data-pid': String(p.id), 'data-title': p.title, 'aria-label': p.title }, [
          img ? h('img', { src: img, alt: p.title }) : h('span', { class: 'hsq-res__noimg' }),
          p.inStock === false || p.in_stock === false ? h('span', { class: 'hsq-res__soldout', text: t.sold_out || 'Немає в наявності' }) : null,
        ]),
        h('div', { class: 'hsq-primary__body' }, [
          h('div', { class: 'hsq-res__head' }, [
            h('div', {}, [
              h('span', { class: 'hsq-badge' + (closest ? '' : ' hsq-badge--land'), text: closest ? (tx.closest_badge || 'Найближчий варіант') : (t.best_badge || 'Найкращий збіг') }),
              h('h3', { class: 'hsq-res__title' }, [h('a', { href: href, 'data-pid': String(p.id), 'data-title': p.title, text: p.title })]),
              p.price ? h('div', { class: 'hsq-res__price', text: formatPrice(p.price, p.currency) }) : null,
            ]),
            typeof p.matchPercent === 'number' ? ring(p.matchPercent) : null,
          ]),
          // Facts: what differs leads when something was relaxed; the ✓ list leads on an exact match.
          h('div', { class: 'hsq-res__group hsq-res__group--facts' }, [
            closest ? notFor : null,
            whyOk.length ? h('ul', { class: 'hsq-why' }, whyOk.map(function (w, i) { return h('li', { style: '--i:' + Math.min(i + (closest ? whyNo.length : 0), 7) }, [h('i', { text: '✓' }), h('span', { text: w.text })]); })) : null,
            eff ? h('p', { class: 'hsq-effect', text: eff }) : null,
            p.attrs && p.attrs.honest_flag ? h('p', { class: 'hsq-honest' }, [h('b', { text: tx.honest_prefix || 'Чесно: ' }), p.attrs.honest_flag]) : null,
            closest ? null : notFor,
            video ? h('div', { class: 'hsq-video' }, [
              h('p', { class: 'hsq-video__title', text: tx.how_to_wear || 'Як одягнути за 30 секунд' }),
              video.kind === 'iframe' ? h('iframe', { src: video.src, allow: 'autoplay; encrypted-media; picture-in-picture', allowfullscreen: 'true', loading: 'lazy', title: tx.how_to_wear || 'Як одягнути' })
                : (video.kind === 'video' ? h('video', { src: video.src, controls: 'true', playsinline: 'true', preload: 'metadata' })
                  : h('a', { class: 'hsq-link', href: video.src, target: '_blank', rel: 'noopener', text: 'Дивитись відео' })),
            ]) : null,
          ]),
          // Action: the CTA with the guarantee and free exchange right under it.
          h('div', { class: 'hsq-res__group hsq-res__group--action' }, [
            h('div', { class: 'hsq-res__foot' }, [h('a', { href: href, class: 'hsq-btn hsq-cta', 'data-pid': String(p.id), 'data-title': p.title, text: tx.cta || 'Обрати розмір' })]),
            trustBlock(t),
          ]),
        ]),
      ]));

      if (res.alternatives.length) {
        var anyExact = res.alternatives.some(function (q) { return q.exact; });
        var pcts = [p].concat(res.alternatives).map(function (x) { return x.matchPercent; });
        var tie = pcts.every(function (v) { return v === pcts[0]; });   // identical percentages say nothing — hide them
        body.push(h('p', { class: 'hsq-also', text: anyExact ? (tx.also || 'Також підійде') : (tx.also_close || 'Інші варіанти') }));
        body.push(h('div', { class: 'hsq-alts' }, res.alternatives.map(function (q) {
          var qa = (q.variants || []).filter(function (v) { return v.available; })[0] || (q.variants || [])[0];
          var qh = safeHref(q.url, qa ? qa.id : null);
          var qi = safeImg(q.image, 500);
          var miss = (q.failedLabels || []);
          var shortTitle = String(q.title || '').replace(/^HolyShape\s+/i, '');
          return h('a', { class: 'hsq-alt' + (q.exact ? ' is-exact' : ''), href: qh, 'data-pid': String(q.id), 'data-title': q.title }, [
            qi ? h('img', { src: qi, alt: q.title, loading: 'lazy' }) : h('span', { class: 'hsq-res__noimg' }),
            h('span', { class: 'hsq-alt__body' }, [
              h('span', { class: 'hsq-alt__title', text: shortTitle }),
              q.price ? h('span', { class: 'hsq-alt__price', text: formatPrice(q.price, q.currency) }) : null,
              Attr.effectLine(fl, q) ? h('span', { class: 'hsq-alt__eff', text: Attr.effectLine(fl, q) }) : null,
              miss.length ? h('span', { class: 'hsq-alt__miss' }, [h('span', { class: 'hsq-alt__misslabel', text: (tx.differs || 'Відрізняється') }), ' ' + miss.join(', ')]) : null,
            ]),
            typeof q.matchPercent === 'number' && !tie ? h('span', { class: 'hsq-alt__pct' + (q.exact ? ' is-exact' : ''), text: q.matchPercent + '%' }) : null,
          ]);
        })));
      }
    }

    var root = h('div', { class: 'hsq-results' }, [
      h('div', { class: 'hsq-results__top' }, [h('button', { type: 'button', class: 'hsq-back hsq-retake', onclick: function () { self.retake(); } }, [arrowLeft(), ' ' + retakeLabel])]),
      h('div', { class: 'hsq-card hsq-card--results hsq-card--attr' }, body.concat([
        h('div', { class: 'hsq-results__bottom' }, [h('button', { type: 'button', class: 'hsq-link-btn', text: t.retake || 'Пройти тест заново ↺', onclick: function () { self.retake(); } })]),
      ])),
    ]);
    this.bindClicks(root, true);
    clear(this.el);
    this.el.appendChild(root);
    focusEl(root.querySelector('.hsq-card--results'));
    this.scrollTop();
  };

  // ── results: tag engine (legacy categories) ──────────────────────────────
  Quiz.prototype.renderResults = function (res, restored) {
    var self = this, cfg = this.config, t = cfg.texts || {}, rc = cfg.results || {};
    var shown = res.products.slice(0, rc.count || 4);
    this.persist('tags');

    if (!restored) {
      var top = shown[0];
      this.trackFinishOnce({ product_id: top ? String(top.id) : null, product_title: top ? top.title : null, match_pct: top && typeof top.matchPercent === 'number' ? top.matchPercent : null, is_fallback: res.isFallback ? 1 : 0, result_count: shown.length, answers: this.answers, relaxations: res.relaxedKeys || [] });
    }

    var title = res.emptyCategory ? (t.empty_category_title || t.fallback_match_title) : (res.isFallback ? t.fallback_match_title : t.exact_match_title);
    var answeredQs = this.answered();
    var retakeLabel = String(t.retake || 'Пройти тест заново').replace('↺', '').trim();

    var cards = shown.map(function (p, idx) {
      var fa = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
      var href = safeHref(p.url, fa ? fa.id : null);
      var pct = typeof p.matchPercent === 'number' ? p.matchPercent : null;
      var chips = [h('span', { class: 'hsq-chip on' }, [h('i', { text: '✓' }), h('span', { text: self.categoryLabel() })])];
      answeredQs.forEach(function (q) {
        var opt = Engine.activeOptions(q).filter(function (o) { return Engine.clean(o.tag) === Engine.clean(self.answers[q.key]); })[0];
        if (!opt) return;
        var ev = p.matchCriteria ? p.matchCriteria[q.key] : null;
        var st = ev ? ev.status : 'miss';
        var cls = st === 'match' ? 'on' : (st === 'near' ? 'near' : 'off');
        chips.push(h('span', { class: 'hsq-chip ' + cls }, [h('i', { text: st === 'match' ? '✓' : (st === 'near' ? '≈' : '•') }), h('span', { text: opt.label })]));
      });
      var img = safeImg(p.image, 700);
      return h('div', { class: 'hsq-res' + (p.inStock === false ? ' is-soldout' : '') }, [
        h('a', { class: 'hsq-res__media', href: href, 'data-pid': String(p.id), 'data-title': p.title, 'aria-label': p.title }, [
          img ? h('img', { src: img, alt: p.title, loading: idx < 2 ? 'eager' : 'lazy' }) : h('span', { class: 'hsq-res__noimg' }),
          p.inStock === false ? h('span', { class: 'hsq-res__soldout', text: t.sold_out || 'Немає в наявності' }) : null,
        ]),
        h('div', { class: 'hsq-res__body' }, [
          h('div', { class: 'hsq-res__head' }, [
            h('div', {}, [
              idx === 0 && pct === 100 ? h('span', { class: 'hsq-badge', text: t.best_badge || 'Найкращий збіг' }) : null,
              h('h3', { class: 'hsq-res__title' }, [h('a', { href: href, 'data-pid': String(p.id), 'data-title': p.title, text: p.title })]),
              p.price ? h('div', { class: 'hsq-res__price', text: formatPrice(p.price, p.currency) }) : null,
            ]),
            pct === null ? null : ring(pct),
          ]),
          h('p', { class: 'hsq-crit', text: t.checklist_title || 'Параметри моделі:' }),
          h('div', { class: 'hsq-chips' }, chips),
          h('div', { class: 'hsq-res__foot' }, [h('a', { href: href, class: 'hsq-btn hsq-cta', 'data-pid': String(p.id), 'data-title': p.title, text: t.view_product || 'Дивитись виріб' })]),
        ]),
      ]);
    });

    var root = h('div', { class: 'hsq-results' }, [
      h('div', { class: 'hsq-results__top' }, [h('button', { type: 'button', class: 'hsq-back hsq-retake', onclick: function () { self.retake(); } }, [arrowLeft(), ' ' + retakeLabel])]),
      h('div', { class: 'hsq-card hsq-card--results' }, [
        h('div', { class: 'hsq-celebrate', text: title }),
        res.relaxed && res.relaxed.length ? h('div', { class: 'hsq-note' }, [h('span', { text: 'ⓘ' }), h('div', { text: fmt(t.relaxed_note || 'У цій категорії зараз немає моделей за критерієм «{labels}». Усе інше ми врахували.', { labels: res.relaxed.join('», «') }) })]) : null,
        h('div', { class: 'hsq-list' }, cards),
        trustBlock(t),
        h('div', { class: 'hsq-results__bottom' }, [h('button', { type: 'button', class: 'hsq-link-btn', text: t.retake || 'Пройти тест заново ↺', onclick: function () { self.retake(); } })]),
      ]),
    ]);
    this.bindClicks(root, true);
    clear(this.el);
    this.el.appendChild(root);
    this.scrollTop();
    setTimeout(function () {
      var rings = root.querySelectorAll('.hsq-ring');
      for (var i = 0; i < rings.length; i++) {
        var pct = Number(rings[i].getAttribute('data-pct')) || 0;
        var val = rings[i].querySelector('.val');
        if (val) val.style.strokeDashoffset = String(163.4 * (1 - pct / 100));
      }
    }, 30);
  };

  Quiz.prototype.retake = function () {
    this.track('retake', {});
    this.reset();
    this.renderStep();
  };

  // ── bits ──────────────────────────────────────────────────────────────────
  // Drawn icons in one stroke weight — never emoji, which render in OS colours.
  function iconShield() {
    return svg('svg', { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true' }, [
      svg('path', { d: 'M12 3l8 3v6c0 4.5-3.2 8-8 9-4.8-1-8-4.5-8-9V6l8-3z' }), svg('polyline', { points: '9 12 11.5 14.5 15.5 10' }),
    ]);
  }
  function iconExchange() {
    return svg('svg', { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true' }, [
      svg('polyline', { points: '17 2 21 6 17 10' }), svg('path', { d: 'M3 12V10a4 4 0 0 1 4-4h14' }), svg('polyline', { points: '7 22 3 18 7 14' }), svg('path', { d: 'M21 12v2a4 4 0 0 1-4 4H3' }),
    ]);
  }
  function pencil() {
    return svg('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2.2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true' }, [
      svg('path', { d: 'M12 20h9' }), svg('path', { d: 'M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z' }),
    ]);
  }
  function trustBlock(t) {
    if (!t.guarantee && !t.exchange) return null;
    return h('div', { class: 'hsq-trust' }, [
      t.guarantee ? h('div', { class: 'hsq-trust__item' }, [iconShield(), h('p', { text: t.guarantee })]) : null,
      t.exchange ? h('div', { class: 'hsq-trust__item' }, [iconExchange(), h('p', { text: t.exchange })]) : null,
    ]);
  }

  function arrowLeft() {
    return svg('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2.5, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true' }, [
      svg('line', { x1: 19, y1: 12, x2: 5, y2: 12 }), svg('polyline', { points: '12 19 5 12 12 5' }),
    ]);
  }
  function tick() {
    return svg('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 3, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true' }, [svg('polyline', { points: '20 6 9 17 4 12' })]);
  }
  function ring(pct) {
    return h('div', { class: 'hsq-ring', 'data-pct': pct, role: 'img', 'aria-label': 'Збіг ' + pct + '%' }, [
      svg('svg', { width: 60, height: 60, viewBox: '0 0 60 60', 'aria-hidden': 'true' }, [
        svg('circle', { class: 'trk', cx: 30, cy: 30, r: 26 }),
        svg('circle', { class: 'val', cx: 30, cy: 30, r: 26, 'stroke-dasharray': '163.4', 'stroke-dashoffset': '163.4' }),
      ]),
      h('b', { text: pct + '%' }),
    ]);
  }
  function formatPrice(amount, currency) {
    var n = Number(amount);
    if (!isFinite(n)) return '';
    try { return n.toLocaleString('uk-UA', { maximumFractionDigits: 0 }) + ' ' + (currency === 'UAH' ? '₴' : (currency || '')); } catch (e) { return Math.round(n) + ' ' + (currency || ''); }
  }

  // ── modal ─────────────────────────────────────────────────────────────────
  function openModal(opts) {
    opts = opts || {};
    var prevOverflow = document.body.style.overflow;
    var mount = h('div', { class: 'hsq-root hsq-root--modal' });
    var dialog = h('div', { class: 'hsq-modal__dialog', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Квіз підбору' }, [
      h('button', { type: 'button', class: 'hsq-modal__close', 'aria-label': 'Закрити', onclick: close }, ['✕']),
      mount,
    ]);
    // Inline positioning as a safety net: if the stylesheet is late or
    // missing, the modal must still cover the screen, not land below the page.
    var overlay = h('div', { class: 'hsq-modal', style: 'position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;background:rgba(8,5,7,.78);overflow:auto' }, [dialog]);
    dialog.style.cssText = 'position:relative;width:min(100%,1040px);max-height:94vh;overflow-y:auto;background:#100C0F;color:#F4ECEE;border-radius:24px;padding:16px';
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(dialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function close() {
      overlay.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
      setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 250);
      showWidgets();
      if (opts.onClose) opts.onClose();
    }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    dialog.setAttribute('tabindex', '-1');
    setTimeout(function () { overlay.classList.add('is-open'); try { dialog.focus({ preventScroll: true }); } catch (e) {} }, 20);   // not rAF: it pauses in background tabs
    var quiz = new Quiz(mount, Object.assign({ mode: 'modal' }, opts));
    quiz.start();
    return { close: close, quiz: quiz };
  }

  function mount(el, opts) {
    var q = new Quiz(el, opts);
    q.start();
    return q;
  }

  function auto() {
    var els = document.querySelectorAll('[data-hs-quiz]');
    for (var i = 0; i < els.length; i++) if (!els[i].__hsq) { els[i].__hsq = mount(els[i]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto); else auto();

  window.HSQuiz = { __v2: true, mount: mount, openModal: openModal, Quiz: Quiz, version: (window.HSQ_BUILD || 'dev') };
})();
